<template>
	<div class="sentiment-container">

		<!-- 添加切换按钮 -->
		<div class="header-controls">
			<div class="title-group">
				<div style="display: flex; align-items: center; gap: 10px;">
					<span class="sub-title" style="font-size: 13px; color: #666; font-weight: normal;">{{subText}}</span>
				</div>
			</div>
			<div class="button-group">
				<button @click="switchModal(0)" :class="['modal-button', {active: modal === 0}, {'disabled-btn': requireSubscription}]">正常K</button>
				<button @click="switchModal(20)" :class="['modal-button', {active: modal === 20}]">情绪K</button>
				<template v-if="isAdmin">
					<div class="divider"></div>
					<button @click="switchMarket(883957)" :class="['modal-button', {active: marketModal === 883957}, {'disabled-btn': requireSubscription}]">正常盘</button>
					<button @click="switchMarket(883404)" :class="['modal-button', {active: marketModal === 883404}]">情绪盘</button>
				</template>
			</div>
		</div>

		<!-- 分钟择时图表 (移到上方) -->
		<div v-if="selectedDate && canViewMinuteTiming" class="minute-timing-section" style="position: relative; margin-top: 10px; margin-bottom: 10px; padding-bottom: 10px; border-bottom: 1px solid #333;">
			<div class="sub-title" style="font-size: 14px; margin-bottom: 5px; color: #ccc; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px;">
				<div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
					<span>{{ selectedDate }} 分钟择时分布 & 分时量能对比 (含5日均量)</span>
					<span class="burst-hint-tag" title="当前柱较前一有效柱放量或缩量幅度达到/超过 100 亿时自动在柱上标记">
						<span class="burst-surge-text">↑放量</span>/<span class="burst-plunge-text">↓缩量</span>&gt;100亿标记
					</span>
					<span v-if="isToday(selectedDate) && isTradingTime()" class="live-tag" :title="'盘中定时任务更新后自动同步 (最近更新: ' + (lastMinuteUpdateTime || '刚刚') + ')'">
						<span class="live-dot"></span>
						盘中自动更新
						<span v-if="lastMinuteUpdateTime" style="margin-left: 4px; opacity: 0.85; font-size: 10px;">{{ lastMinuteUpdateTime }}</span>
					</span>
				</div>
				<span style="font-size: 12px; color: #888; font-weight: normal;">点击下方日K柱可切换日期</span>
			</div>
			<v-chart class="chart-minute-timing" :options="minuteLine" />
			
			<!-- Minute Subscription Overlay -->
			<div v-if="requireMinuteSubscription" class="subscription-overlay subscription-overlay--minute" style="top: 30px; height: calc(100% - 30px); left: 10px; right: 10px;">
				<div class="overlay-content">
					<b-icon icon="lock" class="lock-icon"></b-icon>
					<div class="overlay-text">
						<h3 class="d-none d-md-block">情绪周期VIP</h3>
						<p>解锁[情绪周期VIP]，查看每日分时情绪择时与量能数据。</p>
					</div>
					<b-button variant="primary" size="sm" class="ml-auto" @click="$router.push({ path: '/subscription', query: { module: 'sentiment_vip' }})">
						开通
					</b-button>
				</div>
			</div>
		</div>

		<div style="position: relative;">
			<v-chart class="chart-day-timing" :class="{ 'chart-click-disabled': !canViewMinuteTiming }" :options="line" @datazoom='onDataZoom($event,line)' @click="onChartClick"/>
			
			<!-- Global Subscription Overlay (covers the entire right side) -->
			<div v-if="requireSubscription" class="subscription-overlay-global">
				<div class="overlay-content">
					<b-icon icon="lock" class="lock-icon"></b-icon>
					<div class="overlay-text">
						<h3 class="d-none d-md-block">{{ isUnauthorized ? '请先登录' : '情绪周期VIP' }}</h3>
						<p>{{ isUnauthorized ? '查看更多功能与数据。' : '解锁[情绪周期VIP]，把握清晰的情绪小周期, 躲避主跌, 抓住主升。' }}</p>
						<div class="instruction-link" v-if="!isUnauthorized">
							<a href="https://mp.weixin.qq.com/s/WEntWXOSlTBLaMmwI-UTLA" target="_blank" style="color: #3b82f6; font-size: 12px; text-decoration: underline;">
								<b-icon icon="question-circle" class="mr-1"></b-icon>择时功能使用说明
							</a>
						</div>
					</div>
					<b-button variant="primary" size="sm" class="ml-auto" @click="handleOverlayClick">
						{{ isUnauthorized ? '去登录' : '解锁' }}
					</b-button>
				</div>
			</div>
		</div>

		<div class="footer-note" title="近60个交易日以降低的已确认高点确定上轨，平移下轨并用分散的低价触轨点验证，不要求下轨必须出现反弹后的局部低点；再以MACD DIFF（EMA12−EMA26）最近3个值全部小于0且逐日降低确认。均只使用前一交易日及更早的数据。">浅红“多”柱：全A下降通道，且最近三个DIFF均为负并逐日降低；普通红色为其他正择时。</div>
		<div class="footer-note">感谢<a href="/contact">捐赠</a>服务器费用</div>

		<!-- <div>{{line}}</div> -->
	</div>

</template>

<script>
	import ECharts from 'vue-echarts'

import Moment from 'moment'
import { buildMarketTrendDetails } from '@/utils/marketTrend'
import {
    request_zzquant
} from "network/request.js"
	let dataZoomData = {
		"start": 80,
		"end": 100
	}

	export default {
		props: {
			title: {
				type: String,
				default: "市场情绪周期"
			},
			subText: {
				type: String,
				default: "题材周期"
			},
			bottomSectionMask: {
				type: Boolean,
				default: false
			}
		},
    components: {
        'v-chart': ECharts
    },
    computed: {
        isAdmin() {
            return Array.isArray(this.userRoles) && this.userRoles.includes('admin');
        },
        hasTimingVip() {
            if (this.isAdmin) return true;
            if (this.userSubscriptions && this.userSubscriptions.some(s => s.code === 'sentiment_vip' || s.code === 'topic_kline')) {
                return true;
            }
            if (!this.requireSubscription && !this.isUnauthorized && !!localStorage.getItem('token')) {
                return true;
            }
            return false;
        },
        canViewMinuteTiming() {
            return this.isAdmin || this.hasTimingVip;
        }
    },
    mounted() {
        const c = localStorage.getItem('site.colorblind');
        if(c){ this.colorblind = (c==='1' || c==='true') }
        window.addEventListener('site-colorblind-changed', this.onColorblindChanged)
        
        // 从 localStorage 恢复用户偏好
        this.updateUserRoles()
        this.fetchUserSubscriptions()
        this.onUserLogin = (e) => {
            const userInfo = e && e.detail ? e.detail.userInfo : null;
            this.applyUserRoles(userInfo);
            this.fetchUserSubscriptions();
            this.refresh();
        }
        this.onUserLogout = () => {
            this.userRoles = [];
            this.userSubscriptions = [];
            this.selectedDate = '';
        }
        window.addEventListener('user-login', this.onUserLogin)
        window.addEventListener('user-logout', this.onUserLogout)
        this.onThemeChanged = () => {
            this.refresh();
            if (this.selectedDate) {
                this.fetchMinuteTiming(this.selectedDate);
            }
        };
        window.addEventListener('site-theme-changed', this.onThemeChanged)
        const savedModal = localStorage.getItem('sentiment.modal');
        if (savedModal !== null) this.modal = parseInt(savedModal);

        const savedMarket = localStorage.getItem('sentiment.marketModal');
        if (savedMarket !== null) this.marketModal = parseInt(savedMarket);

        this.refresh();

        // 盘中定时刷新：每 30 秒检查一次，若盘中且正在查看当天分钟择时分布，自动拉取最新数据
        this.autoRefreshTimer = setInterval(this.handleAutoRefresh, 30000);

        // 监听页面可见性切换：用户切回标签页时，若在盘中查看当天，立即触发一次静默刷新
        this.onVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                this.handleAutoRefresh();
            }
        };
        document.addEventListener('visibilitychange', this.onVisibilityChange);
    },
    beforeDestroy(){
        window.removeEventListener('site-colorblind-changed', this.onColorblindChanged);
        window.removeEventListener('user-login', this.onUserLogin);
        window.removeEventListener('user-logout', this.onUserLogout);
        if (this.onThemeChanged) {
            window.removeEventListener('site-theme-changed', this.onThemeChanged);
            this.onThemeChanged = null;
        }
        if (this.autoRefreshTimer) {
            clearInterval(this.autoRefreshTimer);
            this.autoRefreshTimer = null;
        }
        if (this.onVisibilityChange) {
            document.removeEventListener('visibilitychange', this.onVisibilityChange);
            this.onVisibilityChange = null;
        }
    },
    data() {
        return {
            modal: 20, // 默认情绪K
            marketModal: 883404, // 默认情绪盘
            colorblind: false,
            userRoles: [],
            userSubscriptions: [],
            marketTiming: 0,
            requireSubscription: false,
            isUnauthorized: false,
            selectedDate: '',
            requireMinuteSubscription: false,
            autoRefreshTimer: null,
            isFetchingMinuteTiming: false,
            lastMinuteUpdateTime: '',
            autoRefreshTicks: 0,
            minuteDiffValues: [],
            minuteDiffDeltas: [],
            minuteLine: {
                color: ['#a855f7', '#ec0000', '#00da3c', '#ec0000', '#64748b', '#38bdf8', '#f59e0b', '#a855f7'],
                title: { show: false },
                legend: {
                    data: [
                        '均涨幅',
                        { name: '较昨日量差', icon: 'roundRect' },
                        '较5日量差',
                        '较前日量差',
                        '前日成交额',
                        '昨日成交额',
                        '今日成交额',
                        '5日均量'
                    ],
                    selected: {
                        '较昨日量差': true,
                        '较5日量差': true,
                        '较前日量差': true
                    },
                    right: 60,
                    top: 2,
                    textStyle: { color: '#999', fontSize: 11 },
                    itemWidth: 14,
                    itemHeight: 8
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        lineStyle: { color: '#666', type: 'dashed' }
                    },
                    formatter: (params) => this.formatMinuteTooltip(params)
                },
                grid: [
                    { left: 50, right: 60, top: 20, height: 60 },
                    { left: 50, right: 60, top: 105, height: 105 }
                ],
                xAxis: [
                    {
                        gridIndex: 0,
                        type: 'category',
                        data: [],
                        axisLabel: { show: false },
                        axisTick: { show: false },
                        axisLine: { lineStyle: { color: '#444' } },
                        splitLine: { show: false }
                    },
                    {
                        gridIndex: 1,
                        type: 'category',
                        data: [],
                        axisLabel: {
                            color: '#999',
                            fontSize: 10,
                            formatter: (val) => val && val.length > 5 ? val.slice(0, 5) : val
                        },
                        axisTick: { show: true },
                        axisLine: { lineStyle: { color: '#444' } },
                        splitLine: { show: false }
                    }
                ],
                yAxis: [
                    {
                        gridIndex: 0,
                        type: 'value',
                        splitLine: { show: false },
                        axisLabel: { show: false },
                        axisLine: { show: false }
                    },
                    {
                        gridIndex: 1,
                        name: '量差(亿)',
                        nameTextStyle: { color: '#888', fontSize: 9 },
                        type: 'value',
                        position: 'left',
                        scale: true,
                        boundaryGap: ['20%', '20%'],
                        splitLine: { show: true, lineStyle: { color: 'rgba(255,255,255,0.06)', type: 'dashed' } },
                        axisLabel: {
                            color: '#888',
                            fontSize: 9,
                            formatter: '{value}'
                        },
                        axisLine: { show: false }
                    },
                    {
                        gridIndex: 1,
                        name: '累计(亿)',
                        nameTextStyle: { color: '#888', fontSize: 9 },
                        type: 'value',
                        position: 'right',
                        scale: true,
                        splitLine: { show: false },
                        axisLabel: {
                            color: '#888',
                            fontSize: 9,
                            formatter: '{value}'
                        },
                        axisLine: { show: false }
                    },
                    {
                        gridIndex: 0,
                        name: '均涨幅',
                        nameTextStyle: { color: '#888', fontSize: 9 },
                        type: 'value',
                        position: 'right',
                        scale: true,
                        splitLine: { show: false },
                        axisLabel: {
                            color: '#888',
                            fontSize: 9,
                            formatter: '{value}%'
                        },
                        axisLine: { show: false }
                    }
                ],
                series: [
                    {
                        name: '分钟择时',
                        type: 'bar',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        data: [],
                        barMaxWidth: 8,
                        itemStyle: {
                            color: (params) => {
                                const val = params.value;
                                const is0930 = (params.name && params.name.startsWith('09:30'));
                                if (val > 0) return is0930 ? 'rgba(236, 0, 0, 0.15)' : '#ec0000';
                                if (val < 0) return is0930 ? 'rgba(0, 218, 60, 0.15)' : '#00da3c';
                                return 'transparent';
                            },
                            borderRadius: [2, 2, 0, 0]
                        },
                        label: {
                            show: true,
                            position: (params) => params.value > 0 ? 'top' : 'bottom',
                            color: (params) => {
                                const is0930 = (params.name && params.name.startsWith('09:30'));
                                return is0930 ? 'rgba(255, 255, 255, 0.2)' : '#fff';
                            },
                            fontSize: 10,
                            formatter: (params) => {
                                const val = params.value;
                                if (val > 0) return '多';
                                if (val < 0) return '空';
                                return '';
                            }
                        }
                    },
                    {
                        name: '均涨幅',
                        type: 'line',
                        xAxisIndex: 0,
                        yAxisIndex: 3,
                        smooth: true,
                        showSymbol: false,
                        connectNulls: true,
                        z: 3,
                        lineStyle: { width: 1.8, color: '#a855f7' },
                        itemStyle: { color: '#a855f7' },
                        markLine: {
                            silent: true,
                            symbol: 'none',
                            data: [
                                { yAxis: 0, lineStyle: { color: 'rgba(168, 85, 247, 0.35)', type: 'dashed', width: 1 } }
                            ]
                        },
                        data: []
                    },
                    {
                        name: '较昨日量差',
                        type: 'bar',
                        xAxisIndex: 1,
                        yAxisIndex: 1,
                        barMaxWidth: 6,
                        barGap: '15%',
                        z: 2,
                        itemStyle: {
                            color: (params) => {
                                const val = params.value;
                                return val >= 0 ? '#ec0000' : '#00da3c';
                            },
                            borderColor: 'transparent',
                            borderWidth: 0,
                            borderRadius: [2, 2, 0, 0]
                        },
                        label: {
                            show: true,
                            position: (params) => (params.value >= 0 ? 'top' : 'bottom'),
                            distance: 3,
                            formatter: () => '',
                            rich: {}
                        },
                        markLine: {
                            silent: true,
                            symbol: 'none',
                            data: [
                                { yAxis: 0, lineStyle: { color: 'rgba(128, 128, 128, 0.2)', type: 'solid', width: 1 } }
                            ]
                        },
                        data: []
                    },
                    {
                        name: '较5日量差',
                        type: 'bar',
                        xAxisIndex: 1,
                        yAxisIndex: 1,
                        barMaxWidth: 6,
                        z: 2,
                        itemStyle: {
                            color: (params) => {
                                const val = params.value;
                                return val >= 0 ? (this.colorblind ? 'rgba(230, 159, 0, 0.45)' : 'rgba(236, 0, 0, 0.45)') : (this.colorblind ? 'rgba(0, 114, 178, 0.45)' : 'rgba(0, 218, 60, 0.45)');
                            },
                            borderColor: (params) => {
                                const val = params.value;
                                return val >= 0 ? (this.colorblind ? '#E69F00' : '#ec0000') : (this.colorblind ? '#0072B2' : '#00da3c');
                            },
                            borderWidth: 1,
                            borderType: 'dashed',
                            borderRadius: [2, 2, 0, 0]
                        },
                        data: []
                    },
                    {
                        name: '较前日量差',
                        type: 'bar',
                        xAxisIndex: 1,
                        yAxisIndex: 1,
                        barMaxWidth: 6,
                        z: 2,
                        itemStyle: {
                            color: (params) => {
                                const val = params.value;
                                return val >= 0 ? 'rgba(236, 0, 0, 0.35)' : 'rgba(0, 218, 60, 0.35)';
                            },
                            borderColor: (params) => {
                                const val = params.value;
                                return val >= 0 ? 'rgba(236, 0, 0, 0.65)' : 'rgba(0, 218, 60, 0.65)';
                            },
                            borderWidth: 1,
                            borderRadius: [2, 2, 0, 0]
                        },
                        data: []
                    },
                    {
                        name: '前日成交额',
                        type: 'line',
                        xAxisIndex: 1,
                        yAxisIndex: 2,
                        smooth: true,
                        showSymbol: false,
                        connectNulls: true,
                        z: 3,
                        lineStyle: { width: 1.2, color: '#64748b', type: 'dotted' },
                        itemStyle: { color: '#64748b' },
                        data: []
                    },
                    {
                        name: '昨日成交额',
                        type: 'line',
                        xAxisIndex: 1,
                        yAxisIndex: 2,
                        smooth: true,
                        showSymbol: false,
                        connectNulls: true,
                        z: 4,
                        lineStyle: { width: 1.6, color: '#38bdf8' },
                        itemStyle: { color: '#38bdf8' },
                        data: []
                    },
                    {
                        name: '今日成交额',
                        type: 'line',
                        xAxisIndex: 1,
                        yAxisIndex: 2,
                        smooth: true,
                        showSymbol: false,
                        connectNulls: true,
                        z: 5,
                        lineStyle: { width: 2.2, color: '#f59e0b' },
                        itemStyle: { color: '#f59e0b' },
                        data: []
                    },
                    {
                        name: '5日均量',
                        type: 'line',
                        xAxisIndex: 1,
                        yAxisIndex: 2,
                        smooth: true,
                        showSymbol: false,
                        connectNulls: true,
                        z: 2,
                        lineStyle: { width: 1.0, color: 'rgba(148, 163, 184, 0.35)', type: 'dotted' },
                        itemStyle: { color: '#64748b' },
                        data: []
                    }
                ]
            },
            line: {
                title: {
                    show: false,
                    text: this.title,
                    left: 0,
						textStyle: {
							color: '#999999'
						},
                },
                legend: {
                    data: ["K", "MA5", '最高板', '涨停板', '跌停板', '封板率', '上涨数', '大盘K', '大盘MA5', '成交额MA5'],
						textStyle: {
							color: '#999999'
						},
						top: -5
                },
                    grid: [
						{ left: 50, right: 60, top: '2%', height: '10%', backgroundColor: 'rgba(245, 158, 11, 0.05)', show: true }, // Grid 0: Timing
						{ left: 50, right: 60, top: '13%', height: '15%', backgroundColor: 'rgba(128, 128, 128, 0.02)', show: true }, // Grid 1: Main K
						{ left: 50, right: 60, top: '29%', height: '4%', backgroundColor: 'rgba(128, 128, 128, 0.05)', show: true }, // Grid 2: Main Vol
						{ left: 50, right: 60, top: '34%', height: '14%', backgroundColor: 'rgba(128, 128, 128, 0.02)', show: true }, // Grid 3: Highest
						{ left: 50, right: 60, top: '49%', height: '10%', backgroundColor: 'rgba(128, 128, 128, 0.05)', show: true }, // Grid 4: Limit
						{ left: 50, right: 60, top: '60%', height: '8%', backgroundColor: 'rgba(128, 128, 128, 0.02)', show: true }, // Grid 5: Seal Rate
						{ left: 50, right: 60, top: '69%', height: '10%', backgroundColor: 'rgba(128, 128, 128, 0.05)', show: true }, // Grid 6: Market K
						{ left: 50, right: 60, top: '80%', height: '6%', backgroundColor: 'rgba(128, 128, 128, 0.02)', show: true }  // Grid 7: Market Vol
					],
					xAxis: [
						{ gridIndex: 0, type: 'category', data: [], axisLine: { show: false }, axisTick: { show: false }, axisLabel: { show: false }, splitLine: { show: false } }, // Timing
						{ gridIndex: 1, type: 'category', data: [], scale: true, boundaryGap: true, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false }, axisLabel: { show: false } }, // K
						{ gridIndex: 2, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } }, // Vol
						{ gridIndex: 3, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } }, // Highest
						{ gridIndex: 4, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } }, // Limit
						{ gridIndex: 5, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } }, // Seal
						{ gridIndex: 6, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } }, // Market K
						{ gridIndex: 7, type: 'category', data: [], axisLabel: { fontSize: 10, color: '#999999' }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } } // Market Vol
					],
					yAxis: [
						{ 
							gridIndex: 0, 
							type: 'value', 
							scale: true,
							min: (value) => value.min - 4.2,
							max: (value) => value.max + 4.2,
							splitLine: { show: false }, 
							axisLabel: { show: false }, 
							axisLine: { show: false } 
						}, // Timing (Tighter range)
						{ gridIndex: 1, type: 'value', scale: true, axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } }, // K
						{ gridIndex: 2, type: 'value', scale: true, axisLabel: { show: false }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } }, // Vol
						{ gridIndex: 3, type: 'value', scale: true, axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } }, // Highest
						{ gridIndex: 4, type: 'value', scale: true, axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } }, // Limit
						{ gridIndex: 5, type: 'value', min: 0, max: 100, splitNumber: 2, axisLabel: { formatter: '{value}%', color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: true } }, // Seal
						{ gridIndex: 6, type: 'value', scale: true, axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } }, // Market K
						{ gridIndex: 7, type: 'value', scale: true, axisLabel: { show: false }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } }, // Market Vol
						{ gridIndex: 5, type: 'value', scale: true, position: 'left', axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } } // Up Num (on grid 5)
					],
					dataZoom: [
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0, 1, 2, 3, 4, 5, 6, 7],
							top: '88%',
							height: '4%',
							start: dataZoomData.start,
							end: dataZoomData.end,
							textStyle: {
								color: '#999999'
							},
							disabled: false
						}
					],
					tooltip: {
						trigger: 'axis',
						backgroundColor: 'rgba(0, 0, 0, 0.8)',
						borderColor: '#333',
						textStyle: { color: '#eee', fontSize: 12 },
						formatter: function(params) {
							var h = params[0].name + " <br />";
							params.forEach((item) => {
								if (item.seriesName === '择时') return; // 不显示择时
								let v = "";
								if (item.seriesName === 'K' || item.seriesName === '大盘K') {
									let data = item.value;
									let open = data[1];
									let close = data[2];
									let pre_close = data[5];
									let change = ((close - pre_close) / pre_close * 100).toFixed(2);
									v = `<span style="color:${close > open ? '#ec0000' : '#00da3c'}">${close} (${change}%)</span>`;
								} else if (item.seriesName.includes('成交额')) {
									v = (item.value / 100000000).toFixed(2) + ' 亿';
								} else if (item.seriesName.includes('率')) {
									v = item.value + '%';
								} else {
									v = Array.isArray(item.value) ? item.value[1] : item.value;
								}
								h += item.marker + " " + item.seriesName + ": " + v + " <br />";
							});
							return h;
						}
					},
					// 提示联动
                axisPointer: {
                    link: {xAxisIndex: 'all'},
                },
            }
        }
    },
    methods: {
        getChartLegendData() {
            const baseLegend = ["K", "MA5", '最高板', '涨停板', '跌停板', '封板率', '上涨数'];
            if (!this.isAdmin) {
                return baseLegend;
            }
            return [...baseLegend, '大盘K', '大盘MA5', '成交额MA5'];
        },
        getChartLayout() {
            const adminLayout = {
                grid: [
                    { left: 50, right: 60, top: '2%', height: '10%', backgroundColor: 'rgba(245, 158, 11, 0.05)', show: true },
                    { left: 50, right: 60, top: '13%', height: '15%', backgroundColor: 'rgba(128, 128, 128, 0.02)', show: true },
                    { left: 50, right: 60, top: '29%', height: '4%', backgroundColor: 'rgba(128, 128, 128, 0.05)', show: true },
                    { left: 50, right: 60, top: '34%', height: '14%', backgroundColor: 'rgba(128, 128, 128, 0.02)', show: true },
                    { left: 50, right: 60, top: '49%', height: '10%', backgroundColor: 'rgba(128, 128, 128, 0.05)', show: true },
                    { left: 50, right: 60, top: '60%', height: '8%', backgroundColor: 'rgba(128, 128, 128, 0.02)', show: true },
                    { left: 50, right: 60, top: '69%', height: '10%', backgroundColor: 'rgba(128, 128, 128, 0.05)', show: true },
                    { left: 50, right: 60, top: '80%', height: '6%', backgroundColor: 'rgba(128, 128, 128, 0.02)', show: true }
                ],
                xAxis: [
                    { gridIndex: 0, type: 'category', data: [], axisLine: { show: false }, axisTick: { show: false }, axisLabel: { show: false }, splitLine: { show: false } },
                    { gridIndex: 1, type: 'category', data: [], scale: true, boundaryGap: true, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false }, axisLabel: { show: false } },
                    { gridIndex: 2, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 3, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 4, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 5, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 6, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 7, type: 'category', data: [], axisLabel: { fontSize: 10, color: '#999999' }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } }
                ],
                yAxis: [
                    { gridIndex: 0, type: 'value', scale: true, min: (value) => value.min - 4.2, max: (value) => value.max + 4.2, splitLine: { show: false }, axisLabel: { show: false }, axisLine: { show: false } },
                    { gridIndex: 1, type: 'value', scale: true, axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 2, type: 'value', scale: true, axisLabel: { show: false }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 3, type: 'value', scale: true, axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 4, type: 'value', scale: true, axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 5, type: 'value', min: 0, max: 100, splitNumber: 2, axisLabel: { formatter: '{value}%', color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: true } },
                    { gridIndex: 6, type: 'value', scale: true, axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 7, type: 'value', scale: true, axisLabel: { show: false }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 5, type: 'value', scale: true, position: 'left', axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } }
                ],
                dataZoomXAxisIndex: [0, 1, 2, 3, 4, 5, 6, 7],
                dataZoomTop: '88%',
                upNumYAxisIndex: 8
            };

            if (this.isAdmin) {
                return adminLayout;
            }

            return {
                grid: [
                    { left: 50, right: 60, top: '2%', height: '12%', backgroundColor: 'rgba(245, 158, 11, 0.05)', show: true },
                    { left: 50, right: 60, top: '15%', height: '18%', backgroundColor: 'rgba(128, 128, 128, 0.02)', show: true },
                    { left: 50, right: 60, top: '34%', height: '5%', backgroundColor: 'rgba(128, 128, 128, 0.05)', show: true },
                    { left: 50, right: 60, top: '40%', height: '16%', backgroundColor: 'rgba(128, 128, 128, 0.02)', show: true },
                    { left: 50, right: 60, top: '57%', height: '12%', backgroundColor: 'rgba(128, 128, 128, 0.05)', show: true },
                    { left: 50, right: 60, top: '70%', height: '10%', backgroundColor: 'rgba(128, 128, 128, 0.02)', show: true },
                    { left: 50, right: 60, top: '81%', height: 0, backgroundColor: 'rgba(128, 128, 128, 0)', show: false },
                    { left: 50, right: 60, top: '81%', height: 0, backgroundColor: 'rgba(128, 128, 128, 0)', show: false }
                ],
                xAxis: [
                    { gridIndex: 0, type: 'category', data: [], axisLine: { show: false }, axisTick: { show: false }, axisLabel: { show: false }, splitLine: { show: false } },
                    { gridIndex: 1, type: 'category', data: [], scale: true, boundaryGap: true, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false }, axisLabel: { show: false } },
                    { gridIndex: 2, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 3, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 4, type: 'category', data: [], axisLabel: { show: false }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 5, type: 'category', data: [], axisLabel: { fontSize: 10, color: '#999999' }, axisLine: { onZero: false, lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 6, type: 'category', data: [], axisLabel: { show: false }, axisLine: { show: false }, axisTick: { show: false }, splitLine: { show: false } },
                    { gridIndex: 7, type: 'category', data: [], axisLabel: { show: false }, axisLine: { show: false }, axisTick: { show: false }, splitLine: { show: false } }
                ],
                yAxis: [
                    { gridIndex: 0, type: 'value', scale: true, min: (value) => value.min - 4.2, max: (value) => value.max + 4.2, splitLine: { show: false }, axisLabel: { show: false }, axisLine: { show: false } },
                    { gridIndex: 1, type: 'value', scale: true, axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 2, type: 'value', scale: true, axisLabel: { show: false }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 3, type: 'value', scale: true, axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 4, type: 'value', scale: true, axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } },
                    { gridIndex: 5, type: 'value', min: 0, max: 100, splitNumber: 2, axisLabel: { formatter: '{value}%', color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: true } },
                    { gridIndex: 6, type: 'value', scale: true, axisLabel: { show: false }, axisLine: { show: false }, axisTick: { show: false }, splitLine: { show: false } },
                    { gridIndex: 7, type: 'value', scale: true, axisLabel: { show: false }, axisLine: { show: false }, axisTick: { show: false }, splitLine: { show: false } },
                    { gridIndex: 5, type: 'value', scale: true, position: 'left', axisLabel: { color: '#999999' }, axisLine: { lineStyle: { color: '#666666' } }, splitLine: { show: false } }
                ],
                dataZoomXAxisIndex: [0, 1, 2, 3, 4, 5],
                dataZoomTop: '84%',
                upNumYAxisIndex: 8
            };
        },
        applyUserRoles(userInfo) {
            const rolesRaw = userInfo && userInfo.roles;
            this.userRoles = Array.isArray(rolesRaw)
                ? rolesRaw
                : String(rolesRaw || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
            if (!this.canViewMinuteTiming) {
                this.selectedDate = '';
            }
        },
        updateUserRoles() {
            try {
                const raw = localStorage.getItem('user_info');
                if (!raw) {
                    this.userRoles = [];
                    this.selectedDate = '';
                    return;
                }
                const userInfo = JSON.parse(raw);
                this.applyUserRoles(userInfo);
            } catch (e) {
                this.userRoles = [];
                this.selectedDate = '';
            }
        },
        fetchUserSubscriptions() {
            if (!localStorage.getItem('token')) {
                this.userSubscriptions = [];
                return;
            }
            request_zzquant({ url: '/v3/user/subscriptions', method: 'get' }).then(res => {
                if (res && res.data && res.data.code === 20000) {
                    this.userSubscriptions = res.data.data.feature_subscriptions || [];
                }
            }).catch(() => {});
        },
        onColorblindChanged(e){ const v = e && e.detail && typeof e.detail.colorblind!== 'undefined' ? !!e.detail.colorblind : (localStorage.getItem('site.colorblind')==='1' || localStorage.getItem('site.colorblind')==='true'); this.colorblind = v; this.refresh() },
			splitData(rawData) {
				let [categoryData,max_lb_num,lb_3_num,uplimit_num,downlimit_num,max_lb_stocks,damian_num,second_lb_num,fb_num,mian_num,bigleg_num, up_num, market_timing_data, timing_signal_type_data ]= [[],[],[],[],[],[],[],[],[],[],[],[], [], []];
				let [uplimit_num_m,downlimit_num_m ]= [[],[]];
				let [mark_line_mon, mark_line_day1] = [[],[]];
				let pre_month = -1;
				for (var i = 0; i < rawData.length; i++) {
					let item_date = rawData[i]['date1'];
					categoryData.push(rawData[i]['date1']);
					max_lb_num.push(rawData[i]['max_lb_num']);
					second_lb_num.push(rawData[i]['second_lb_num']);
					lb_3_num.push(rawData[i]['lb_3_num']);
					max_lb_stocks.push(rawData[i]['max_lb_stock_names'] || rawData[i]['max_lb_stocks']);
					damian_num.push(rawData[i]['damian_num']);
					fb_num.push(rawData[i]['fb_num']);
					mian_num.push(rawData[i]['mian_num']);
					bigleg_num.push(rawData[i]['bigleg_num']);
					up_num.push(rawData[i]['up_num']);
					market_timing_data.push(rawData[i]['market_timing'] || 0);
					timing_signal_type_data.push(rawData[i]['timing_signal_type'] || 0);

					uplimit_num.push(rawData[i]['uplimit_num']);
					downlimit_num.push(rawData[i]['downlimit_num']);
					var uplimit = rawData[i]['uplimit_num']
					uplimit_num_m.push([rawData[i]['date1'], uplimit, 1]);
					var downlimit = rawData[i]['downlimit_num'];
					downlimit_num_m.push([rawData[i]['date1'], -downlimit, 1]);
					
					// 计算周一
					if(Moment(item_date).day()==1){
						mark_line_mon.push({
							xAxis:item_date,
							label: {formatter: item_date.substr(8)},
							})
					}
					if(Moment(item_date).month()!=pre_month){
						mark_line_day1.push({
							name:"月初", 
							label: {formatter: item_date.substr(5)},
							xAxis:item_date,
							})
						pre_month = Moment(item_date).month()
					}
				}
				return {
					categoryData: categoryData,
					max_lb_num: max_lb_num,
					second_lb_num: second_lb_num,
					lb_3_num: lb_3_num,
					uplimit_num: uplimit_num,
					downlimit_num: downlimit_num,
					downlimit_num_m: downlimit_num_m,
					uplimit_num_m: uplimit_num_m,
					max_lb_stocks: max_lb_stocks,
					damian_num: damian_num,
					fb_num: fb_num,
					mian_num: mian_num,
					bigleg_num: bigleg_num,
					up_num: up_num,
					market_timing_data: market_timing_data,
					timing_signal_type_data: timing_signal_type_data,
					mark_line_mon:mark_line_mon,
					mark_line_day1:mark_line_day1,
				};
			},
			formatTimingSignalType(signalType) {
				const signalMap = {
					1: '开盘竞价',
					2: '开盘确认',
					3: '开盘五分',
					'-1': '竞价风险',
					'-2': '确认风险',
					'-3': '五分风险'
				};
				return signalMap[String(signalType)] || '';
			},
			getTimingSignalScatterData(data, isDark) {
				const signalThemes = {
					1: {
						darkBg: 'rgba(251, 191, 36, 0.62)',
						darkText: '#fff7d6',
						darkBorder: 'rgba(255, 243, 199, 0.9)',
						lightBg: 'rgba(217, 119, 6, 0.52)',
						lightText: '#fffaf0',
						lightBorder: 'rgba(245, 158, 11, 0.78)'
					},
					2: {
						darkBg: 'rgba(245, 158, 11, 0.58)',
						darkText: '#fff7d6',
						darkBorder: 'rgba(255, 243, 199, 0.88)',
						lightBg: 'rgba(202, 138, 4, 0.50)',
						lightText: '#fffaf0',
						lightBorder: 'rgba(234, 179, 8, 0.74)'
					},
					3: {
						darkBg: 'rgba(234, 179, 8, 0.54)',
						darkText: '#fff7d6',
						darkBorder: 'rgba(254, 240, 138, 0.86)',
						lightBg: 'rgba(180, 83, 9, 0.48)',
						lightText: '#fffaf0',
						lightBorder: 'rgba(217, 119, 6, 0.72)'
					},
					'-1': {
						darkBg: 'rgba(251, 191, 36, 0.60)',
						darkText: '#fff7d6',
						darkBorder: 'rgba(255, 243, 199, 0.9)',
						lightBg: 'rgba(180, 83, 9, 0.50)',
						lightText: '#fffaf0',
						lightBorder: 'rgba(245, 158, 11, 0.76)'
					},
					'-2': {
						darkBg: 'rgba(245, 158, 11, 0.56)',
						darkText: '#fff7d6',
						darkBorder: 'rgba(255, 243, 199, 0.88)',
						lightBg: 'rgba(202, 138, 4, 0.48)',
						lightText: '#fffaf0',
						lightBorder: 'rgba(234, 179, 8, 0.72)'
					},
					'-3': {
						darkBg: 'rgba(234, 179, 8, 0.52)',
						darkText: '#fff7d6',
						darkBorder: 'rgba(254, 240, 138, 0.84)',
						lightBg: 'rgba(180, 83, 9, 0.46)',
						lightText: '#fffaf0',
						lightBorder: 'rgba(217, 119, 6, 0.70)'
					}
				};
				const signalLabels = {
					1: '竞',
					2: '确',
					3: '五',
					'-1': '危',
					'-2': '险',
					'-3': '警'
				};
				const laneLastIndex = {
					top: [],
					bottom: []
				};
				return data.categoryData.reduce((points, date, idx) => {
					const signalType = Number(data.timing_signal_type_data[idx] || 0);
					if (!signalType) {
						return points;
					}
					const timingValue = Number(data.market_timing_data[idx] || 0);
					const laneKey = signalType > 0 ? 'top' : 'bottom';
					let laneLevel = 0;
					while (
						laneLastIndex[laneKey][laneLevel] !== undefined &&
						idx - laneLastIndex[laneKey][laneLevel] <= 4
					) {
						laneLevel += 1;
					}
					laneLastIndex[laneKey][laneLevel] = idx;
					const anchorValue = signalType > 0 ? Math.max(timingValue, 0) : Math.min(timingValue, 0);
					const laneStep = 0.95;
					const baseOffset = signalType > 0 ? 1.9 : -1.9;
					const laneOffset = laneLevel * (signalType > 0 ? laneStep : -laneStep);
					const yValue = anchorValue + baseOffset + laneOffset;
					const theme = signalThemes[String(signalType)] || signalThemes[1];
					points.push({
						name: this.formatTimingSignalType(signalType),
						value: [date, yValue],
						signalType: signalType,
						itemStyle: {
							color: isDark ? theme.darkBg : theme.lightBg,
							borderColor: isDark ? theme.darkBorder : theme.lightBorder,
							borderWidth: 1.2,
							shadowBlur: isDark ? 8 : 4,
							shadowColor: isDark ? 'rgba(15, 23, 42, 0.45)' : 'rgba(148, 163, 184, 0.35)'
						},
						label: {
							show: true,
							position: 'inside',
							formatter: signalLabels[String(signalType)] || '',
							color: isDark ? theme.darkText : theme.lightText,
							fontSize: 10,
							fontWeight: 'bold'
						},
						tooltip: {
							formatter: `${date}<br/>信号: ${this.formatTimingSignalType(signalType)}`
						}
					});
					return points;
				}, []);
			},
			splitKlineData(rawData) {
				let categoryData = [];
				let values = [];
                let volumes = [];
				let p_close_pre1d = [];
				let iceData = [];
				let mark_line_mon = [];
				let mark_line_day1 = [];
				let pre_week = -1;
				let pre_month = -1;
				const weekdayMap = { 1: '周一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六', 0: '日' };
				
				for (let i = 0; i < rawData.length; i++) {
					let item = rawData[i];
					let item_date = item['date']
					let moment_date = Moment(item_date);
					categoryData.push(item_date);
					values.push([
						item['p_open'], 
						item['p_close'], 
						item['p_high'], 
						item['p_low'], 
						item['p_close_pre1d'] || item['p_prev_close']
					]);
					volumes.push(item['amount'] || item['turnover'] || 0);
					p_close_pre1d.push(item['p_close_pre1d'])
					
					// 处理冰点数据
					if (i > 0) {
						const prevClose = item['p_close_pre1d'];
						const currClose = item['p_close'];
						const changePercent = ((currClose - prevClose) / prevClose * 100).toFixed(2);
						
						if (parseFloat(changePercent) <= -2) {
							iceData.push({
								name: 'Ice',
								value: changePercent,
								xAxis: i,
								yAxis: currClose
							});
						}
					}
					
					// 计算月初第一天
					let isMonthStart = false;
					if(moment_date.month() !== pre_month){
						mark_line_day1.push({
							name: "月初", 
							label: { formatter: item_date.substr(5) },
							xAxis: item_date
						});
						pre_month = moment_date.month();
						isMonthStart = true;
					}

					// 计算每周第一天
					let current_week = moment_date.isoWeek();
					if (current_week !== pre_week) {
						if (!isMonthStart) {
							mark_line_mon.push({
								xAxis: item_date,
								label: { formatter: weekdayMap[moment_date.day()] }
							});
						}
						pre_week = current_week;
					}
				}
				
				return {
					categoryData: categoryData,
					values: values,
                    volumes: volumes,
					iceData: iceData,
					mark_line_mon: mark_line_mon,
					mark_line_day1: mark_line_day1
				};
			},
			splitZhabanData(rawData) {
				var categoryData = [], zb_pct = [], num_lb=[];
				
				for (var i = 0; i < rawData.length; i++) {
					categoryData.push(rawData[i]['date1']);
					zb_pct.push((rawData[i]['uplimit_n_num'] / (rawData[i]['zb_num'] + rawData[i]['uplimit_n_num']) * 100).toFixed(2))
					num_lb.push(rawData[i]['uplimit_n_num'])
				}
				
				return {
					categoryData: categoryData,
					zb_pct: zb_pct,
					num_lb:num_lb,
				};
			},
			calculateMAForKline(dayCount, data) {
				let result = [];
				for (let i = 0, len = data.length; i < len; i++) {
					if (i < dayCount - 1) {
						result.push('-');
						continue;
					}
					let sum = 0;
					for (let j = 0; j < dayCount; j++) {
						sum += data[i - j][1]; // 使用收盘价
					}
					result.push(+(sum / dayCount).toFixed(3));
				}
				return result;
			},
			calculateMAForVolume(dayCount, data) {
				let result = [];
				for (let i = 0, len = data.length; i < len; i++) {
					if (i < dayCount - 1) {
						result.push('-');
						continue;
					}
					let sum = 0;
					for (let j = 0; j < dayCount; j++) {
						sum += data[i - j]; 
					}
					result.push(+(sum / dayCount).toFixed(3));
				}
				return result;
			},
			calculateMA(dayCount, data) {
				var result = [];
				for (var i = 0, len = data.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-');
						continue;
					}
					var sum = 0;
					for (var j = 0; j < dayCount; j++) {
						sum += data[i - j][1];
					}
					result.push(+(sum / dayCount).toFixed(2));
				}
				return result;
			},
			get_mark_point_data(data) {
				var point_data = [];
				for (var i = 0; i < data.lb_3_num.length; i++) {
					if (data.lb_3_num[i] <= 1) {
						point_data.push({
							name: '机会',
							value: data.lb_3_num[i],
							xAxis: data.categoryData[i],
							yAxis: data.max_lb_num[i]
						})
					}
				}
				return point_data
			},
			get_mark_point_data_damian(data) {
				var point_data = [];
				for (var i = 0; i < data.damian_num.length; i++) {
					if (data.damian_num[i] > 0) {
						point_data.push({
							name: '风险',
							value: data.damian_num[i],
							xAxis: data.categoryData[i],
							yAxis: data.max_lb_num[i]
						})
					}
				}
				return point_data
			},
			onDataZoom(event,option){
				if(event.type == 'datazoom'){
                    if(this.requireSubscription) {
                        // 没权限时阻止 dataZoom 事件改变数据，并恢复为初始比例
                        this.line.dataZoom[0].start = this._originalDataZoomStart || 80;
                        this.line.dataZoom[0].end = this._originalDataZoomEnd || 100;
                        this.showVipPrompt();
                        return;
                    }
					let last_end = event.end
					if(event.start == 0){
						let data_start = Moment(option.xAxis[0].data[0])
						if(data_start <= Moment('2015-01-05')){
							return
						}
						let data_start_new = data_start.add(-1,'years').format("YYYY-MM-DD")
						this.line.dataZoom[0].start=10
						this.line.dataZoom[0].end=last_end
						this.refresh(data_start_new)
					}
				}
			},
			switchMarket(code) {
                if (!this.isAdmin) {
                    return;
                }
                if (this.requireSubscription && code === 883957) {
                    this.showVipPrompt();
                    return;
                }
				this.marketModal = code;
				localStorage.setItem('sentiment.marketModal', code);
				this.refresh();
			},
			switchModal(modal) {
                if (this.requireSubscription && modal === 0) {
                    this.showVipPrompt();
                    return;
                }
				this.modal = modal;
				localStorage.setItem('sentiment.modal', modal);
				this.refresh();
			},
            showVipPrompt() {
                if (!this._isShowingVipModal) {
                    this._isShowingVipModal = true;
                    
                    if (this.isUnauthorized) {
                        this.$bvModal.msgBoxConfirm('请先登录后查看更多数据与功能。', {
                            title: '提示',
                            okTitle: '去登录',
                            cancelTitle: '取消',
                            centered: true,
                            okVariant: 'primary'
                        }).then(value => {
                            this._isShowingVipModal = false;
                            if (value) {
                                const current = this.$router.currentRoute && this.$router.currentRoute.fullPath ? this.$router.currentRoute.fullPath : '/';
                                this.$router.push({ path: '/login', query: { redirect: current } });
                            }
                        }).catch(() => {
                            this._isShowingVipModal = false;
                        });
                        return;
                    }

                    const h = this.$createElement;
                    const messageVNode = h('div', { class: 'text-center' }, [
                        h('p', { class: 'mb-3' }, '解锁[情绪周期VIP]，把握清晰的情绪小周期, 躲避主跌, 抓住主升。'),
                        h('a', { 
                            attrs: { 
                                href: 'https://mp.weixin.qq.com/s/WEntWXOSlTBLaMmwI-UTLA', 
                                target: '_blank' 
                            },
                            style: 'color: #3b82f6; font-size: 13px; text-decoration: underline; display: flex; align-items: center; justify-content: center;'
                        }, [
                            h('b-icon', { props: { icon: 'question-circle' }, class: 'mr-1' }),
                            '择时功能使用说明'
                        ])
                    ]);

                    this.$bvModal.msgBoxConfirm([messageVNode], {
                        title: '情绪周期VIP',
                        okTitle: '前往开通',
                        cancelTitle: '取消',
                        centered: true,
                        okVariant: 'primary',
                        headerBgVariant: 'dark',
                        headerTextVariant: 'light',
                        bodyBgVariant: 'dark',
                        bodyTextVariant: 'light',
                        footerBgVariant: 'dark'
                    }).then(value => {
                        this._isShowingVipModal = false;
                        if (value) {
                            this.$router.push({ path: '/subscription', query: { module: 'sentiment_vip' }});
                        }
                    }).catch(() => {
                        this._isShowingVipModal = false;
                    });
                }
            },
            handleOverlayClick() {
                if (this.isUnauthorized) {
                    const current = this.$router.currentRoute && this.$router.currentRoute.fullPath ? this.$router.currentRoute.fullPath : '/';
                    this.$router.push({ path: '/login', query: { redirect: current } });
                } else {
                    this.$router.push({ path: '/subscription', query: { module: 'sentiment_vip' }});
                }
            },
            onChartClick(params) {
                if (!this.canViewMinuteTiming) {
                    this.showVipPrompt();
                    return;
                }
                let date = '';
                if (params.name && /^\d{4}-\d{2}-\d{2}$/.test(params.name)) {
                    date = params.name;
                } else if (params.dataIndex !== undefined) {
                    let axis = this.line.xAxis[params.xAxisIndex || 0];
                    if (axis && axis.data) {
                        date = axis.data[params.dataIndex];
                    }
                }
                
                if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
                    this.selectedDate = date;
                    this.fetchMinuteTiming(date);
                }
            },
            formatMinuteTooltip(params) {
                if (!params || !params.length) return '';
                const upColor = this.colorblind ? '#E69F00' : '#ec0000';
                const downColor = this.colorblind ? '#0072B2' : '#00da3c';
                const upColorAlpha = this.colorblind ? 'rgba(230, 159, 0, 0.15)' : 'rgba(236, 0, 0, 0.15)';
                const downColorAlpha = this.colorblind ? 'rgba(0, 114, 178, 0.15)' : 'rgba(0, 218, 60, 0.15)';
                let time = params[0].name || (params[0].axisValueLabel || '');
                let displayTime = time && time.length > 5 ? time.slice(0, 5) : time;
                const is0930 = time && time.startsWith('09:30');
                if (is0930) {
                    displayTime = `${displayTime} (开盘竞价)`;
                }
                let res = `<div style="font-weight:bold;margin-bottom:4px;border-bottom:1px solid rgba(255,255,255,0.15);padding-bottom:2px;">${displayTime}</div>`;

                let timingItem = params.find(p => p.seriesName === '分钟择时');
                if (timingItem && timingItem.value !== undefined && timingItem.value !== null) {
                    let val = timingItem.value;
                    let color = val > 0 ? upColor : (val < 0 ? downColor : '#ccc');
                    let colorAlpha = val > 0 ? upColorAlpha : (val < 0 ? downColorAlpha : '#ccc');
                    let text = val > 0 ? (is0930 ? '竞价多' : '多') : (val < 0 ? (is0930 ? '竞价空' : '空') : '平');
                    let dotColor = is0930 ? colorAlpha : color;
                    res += `<div style="margin-bottom:3px;"><span style="display:inline-block;margin-right:5px;border-radius:2px;width:8px;height:8px;background-color:${dotColor};"></span>分钟择时: <b style="color:${color}">${text} (${val})</b>${is0930 ? ' <span style="font-size:10px;color:#94a3b8;">(竞价切片·恒定)</span>' : ''}</div>`;
                }

                // 均涨幅 (高亮走势，判断放量涨跌)
                let avgPctItem = params.find(p => p.seriesName === '均涨幅');
                let avgPctVal = null;
                if (avgPctItem && avgPctItem.value !== undefined && avgPctItem.value !== null) {
                    avgPctVal = Number(avgPctItem.value);
                    let pctColor = avgPctVal > 0 ? upColor : (avgPctVal < 0 ? downColor : '#94a3b8');
                    let pctSign = avgPctVal > 0 ? '+' : '';
                    res += `<div style="margin-bottom:4px;display:flex;justify-content:space-between;align-items:center;">
                        <span><span style="display:inline-block;margin-right:5px;border-radius:50%;width:7px;height:7px;background-color:#a855f7;"></span>市场均涨幅:</span>
                        <b style="color:${pctColor};font-size:12px;">${pctSign}${avgPctVal.toFixed(2)}%</b>
                    </div>`;
                }

                let diffItem = params.find(p => p.seriesName === '较昨日量差');
                let diffVal = null;
                if (diffItem && diffItem.value !== undefined && diffItem.value !== null) {
                    let rawVal = diffItem.value;
                    if (typeof rawVal === 'object' && rawVal !== null) {
                        rawVal = Array.isArray(rawVal) ? rawVal[1] : (rawVal.value !== undefined ? rawVal.value : rawVal);
                    }
                    diffVal = Number(rawVal);
                    let diffColor = diffVal >= 0 ? upColor : downColor;
                    let diffSign = diffVal >= 0 ? '+' : '';
                    let label = diffVal >= 0 ? '较昨日放量' : '较昨日缩量';
                    let bg = diffVal >= 0 ? (this.colorblind ? 'rgba(230,159,0,0.15)' : 'rgba(236,0,0,0.12)') : (this.colorblind ? 'rgba(0,114,178,0.15)' : 'rgba(0,218,60,0.12)');
                    let border = diffVal >= 0 ? (this.colorblind ? 'rgba(230,159,0,0.35)' : 'rgba(236,0,0,0.3)') : (this.colorblind ? 'rgba(0,114,178,0.35)' : 'rgba(0,218,60,0.3)');

                    // 量价配合诊断标签
                    let vTag = '';
                    if (avgPctVal !== null) {
                        if (diffVal > 0 && avgPctVal > 0) vTag = `<span style="margin-left:6px;font-size:10px;padding:1px 4px;border-radius:3px;background:rgba(236,0,0,0.22);color:${upColor};font-weight:bold;">放量上涨</span>`;
                        else if (diffVal > 0 && avgPctVal < 0) vTag = `<span style="margin-left:6px;font-size:10px;padding:1px 4px;border-radius:3px;background:rgba(0,218,60,0.22);color:${downColor};font-weight:bold;">放量下跌</span>`;
                        else if (diffVal <= 0 && avgPctVal > 0) vTag = `<span style="margin-left:6px;font-size:10px;padding:1px 4px;border-radius:3px;background:rgba(236,0,0,0.12);color:${upColor};">缩量上涨</span>`;
                        else if (diffVal <= 0 && avgPctVal < 0) vTag = `<span style="margin-left:6px;font-size:10px;padding:1px 4px;border-radius:3px;background:rgba(0,218,60,0.12);color:${downColor};">缩量下跌</span>`;
                    }

                    res += `<div style="margin:4px 0 2px 0;padding:2px 6px;background:${bg};border-radius:4px;border:1px solid ${border};font-size:12px;display:flex;justify-content:space-between;align-items:center;">
                        <div><span style="color:${diffColor};">${label}</span>${vTag}</div>
                        <b style="color:${diffColor};">${diffSign}${diffVal.toFixed(2)} 亿</b>
                    </div>`;

                    // 较前一有效柱环比变动（放量/缩量 > 100亿强提示）
                    const curIdx = diffItem.dataIndex !== undefined ? diffItem.dataIndex : (params[0] ? params[0].dataIndex : -1);
                    if (curIdx >= 0 && this.minuteDiffDeltas && this.minuteDiffDeltas[curIdx] !== null && this.minuteDiffDeltas[curIdx] !== undefined) {
                        const delta = this.minuteDiffDeltas[curIdx];
                        const deltaSign = delta >= 0 ? '+' : '';
                        if (delta >= 100) {
                            res += `<div style="margin:2px 0 4px 0;padding:2px 6px;background:rgba(236,0,0,0.18);border-radius:3px;border:1px solid ${upColor};font-size:11px;display:flex;justify-content:space-between;align-items:center;">
                                <span style="color:${upColor};font-weight:bold;">↑ 较前柱放量:</span>
                                <span style="color:${upColor};font-weight:bold;">${deltaSign}${delta.toFixed(2)} 亿 <span style="font-size:10px;padding:0 4px;border-radius:2px;background:${upColor};color:#fff;margin-left:4px;">放量&gt;100亿</span></span>
                            </div>`;
                        } else if (delta <= -100) {
                            res += `<div style="margin:2px 0 4px 0;padding:2px 6px;background:rgba(0,218,60,0.18);border-radius:3px;border:1px solid ${downColor};font-size:11px;display:flex;justify-content:space-between;align-items:center;">
                                <span style="color:${downColor};font-weight:bold;">↓ 较前柱缩量:</span>
                                <span style="color:${downColor};font-weight:bold;">${delta.toFixed(2)} 亿 <span style="font-size:10px;padding:0 4px;border-radius:2px;background:${downColor};color:#fff;margin-left:4px;">缩量&gt;100亿</span></span>
                            </div>`;
                        } else {
                            const dColor = delta >= 0 ? upColor : downColor;
                            res += `<div style="margin:1px 0 3px 0;padding:0 6px;font-size:11px;color:#94a3b8;display:flex;justify-content:space-between;align-items:center;">
                                <span>较前柱量变:</span>
                                <span style="color:${dColor};">${deltaSign}${delta.toFixed(2)} 亿</span>
                            </div>`;
                        }
                    }
                }

                // 较5日量差 (核心基准对比：虚线边框柱、放量/缩量诊断)
                let diffMA5Item = params.find(p => p.seriesName === '较5日量差');
                if (diffMA5Item && diffMA5Item.value !== undefined && diffMA5Item.value !== null) {
                    let diff = Number(diffMA5Item.value);
                    let diffColor = diff >= 0 ? upColor : downColor;
                    let diffSign = diff >= 0 ? '+' : '';
                    let label = diff >= 0 ? '较5日均放量' : '较5日均缩量';
                    let ma5Bg = diff >= 0 ? (this.colorblind ? 'rgba(230,159,0,0.12)' : 'rgba(236,0,0,0.1)') : (this.colorblind ? 'rgba(0,114,178,0.12)' : 'rgba(0,218,60,0.1)');
                    let ma5Border = diff >= 0 ? (this.colorblind ? 'rgba(230,159,0,0.35)' : 'rgba(236,0,0,0.3)') : (this.colorblind ? 'rgba(0,114,178,0.35)' : 'rgba(0,218,60,0.3)');

                    let ma5Tag = '';
                    if (avgPctVal !== null) {
                        if (diff > 0 && avgPctVal > 0) ma5Tag = `<span style="margin-left:6px;font-size:10px;padding:1px 4px;border-radius:3px;background:rgba(236,0,0,0.22);color:${upColor};font-weight:bold;">5日放量涨</span>`;
                        else if (diff > 0 && avgPctVal < 0) ma5Tag = `<span style="margin-left:6px;font-size:10px;padding:1px 4px;border-radius:3px;background:rgba(0,218,60,0.22);color:${downColor};font-weight:bold;">5日放量跌</span>`;
                        else if (diff <= 0 && avgPctVal > 0) ma5Tag = `<span style="margin-left:6px;font-size:10px;padding:1px 4px;border-radius:3px;background:rgba(236,0,0,0.12);color:${upColor};">5日缩量涨</span>`;
                        else if (diff <= 0 && avgPctVal < 0) ma5Tag = `<span style="margin-left:6px;font-size:10px;padding:1px 4px;border-radius:3px;background:rgba(0,218,60,0.12);color:${downColor};">5日缩量跌</span>`;
                    }

                    res += `<div style="margin:2px 0;padding:2px 6px;background:${ma5Bg};border-radius:3px;border:1px dashed ${ma5Border};font-size:12px;display:flex;justify-content:space-between;align-items:center;">
                        <div><span style="color:${diffColor};">${label}</span>${ma5Tag}</div>
                        <b style="color:${diffColor};">${diffSign}${diff.toFixed(2)} 亿</b>
                    </div>`;
                }

                // 较前日量差 (次要并列柱：半透明浅色框、轻量字号)
                let diffBeforeItem = params.find(p => p.seriesName === '较前日量差');
                if (diffBeforeItem && diffBeforeItem.value !== undefined && diffBeforeItem.value !== null) {
                    let diff = Number(diffBeforeItem.value);
                    let diffColor = diff >= 0 ? upColor : downColor;
                    let diffSign = diff >= 0 ? '+' : '';
                    let label = diff >= 0 ? '较前日放量' : '较前日缩量';
                    let subBg = diff >= 0 ? (this.colorblind ? 'rgba(230,159,0,0.08)' : 'rgba(236,0,0,0.07)') : (this.colorblind ? 'rgba(0,114,178,0.08)' : 'rgba(0,218,60,0.07)');
                    let subBorder = diff >= 0 ? (this.colorblind ? 'rgba(230,159,0,0.25)' : 'rgba(236,0,0,0.22)') : (this.colorblind ? 'rgba(0,114,178,0.25)' : 'rgba(0,218,60,0.22)');
                    res += `<div style="margin:2px 0 4px 0;padding:2px 6px;background:${subBg};border-radius:3px;border:1px solid ${subBorder};font-size:11px;display:flex;justify-content:space-between;align-items:center;color:#94a3b8;">
                        <span><span style="display:inline-block;width:7px;height:7px;background:${diffColor};opacity:0.5;border-radius:1px;margin-right:4px;vertical-align:middle;"></span>${label}:</span>
                        <span style="color:${diffColor};font-weight:600;font-size:11px;">${diffSign}${diff.toFixed(2)} 亿</span>
                    </div>`;
                }

                let amountItems = params.filter(p => p.seriesName !== '分钟择时' && p.seriesName !== '均涨幅' && p.seriesName !== '较昨日量差' && p.seriesName !== '较5日量差' && p.seriesName !== '较前日量差' && p.seriesName && p.value !== null && p.value !== undefined);
                if (amountItems.length > 0) {
                    res += `<div style="margin-top:4px;border-top:1px dashed rgba(255,255,255,0.15);padding-top:3px;font-size:11px;color:#aaa;">累计成交额:</div>`;
                    amountItems.forEach(item => {
                        let valStr = Number(item.value).toFixed(2) + ' 亿';
                        let isMA5 = item.seriesName === '5日均量';
                        let rowStyle = isMA5 ? 'display:flex;justify-content:space-between;gap:12px;font-size:11px;color:#94a3b8;' : 'display:flex;justify-content:space-between;gap:12px;font-size:12px;';
                        let valWeight = isMA5 ? 'font-weight:normal;' : 'font-weight:bold;';
                        res += `<div style="${rowStyle}"><span>${item.marker} ${item.seriesName}:</span><span style="${valWeight}">${valStr}</span></div>`;
                    });
                }
                return res;
            },
            isTradingTime() {
                // 基于北京时间 (UTC+8) 判断盘中交易时段
                const now = new Date();
                const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
                const bjDate = new Date(utc + (3600000 * 8));
                
                const day = bjDate.getDay(); // 0 是周日，6 是周六
                if (day === 0 || day === 6) return false;
                
                const hours = bjDate.getHours();
                const minutes = bjDate.getMinutes();
                const timeVal = hours * 100 + minutes;
                
                // 交易时间段：早盘 09:25 - 11:35，午盘 13:00 - 15:05
                return (timeVal >= 925 && timeVal <= 1135) || (timeVal >= 1300 && timeVal <= 1505);
            },
            getBeijingTodayStr() {
                const now = new Date();
                const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
                const bjDate = new Date(utc + (3600000 * 8));
                const y = bjDate.getFullYear();
                const m = String(bjDate.getMonth() + 1).padStart(2, '0');
                const d = String(bjDate.getDate()).padStart(2, '0');
                return `${y}-${m}-${d}`;
            },
            isToday(date) {
                return date === this.getBeijingTodayStr();
            },
            handleAutoRefresh() {
                if (!this.canViewMinuteTiming) return;
                if (!this.isTradingTime()) return;

                const todayStr = this.getBeijingTodayStr();
                // 仅当用户当前查看的是当天的分钟择时分布时才自动刷新
                if (this.selectedDate !== todayStr) {
                    return;
                }

                if (this.isFetchingMinuteTiming) {
                    return;
                }

                this.autoRefreshTicks = (this.autoRefreshTicks || 0) + 1;
                // 每 2 分钟 (每 4 个 30 秒周期) 触发一次整体日K刷新（日K刷新也会更新分时数据）
                if (this.autoRefreshTicks % 4 === 0) {
                    this.refresh();
                } else {
                    // 平常每 30 秒直接拉取当天的分钟择时与近三日量能对比
                    this.fetchMinuteTiming(this.selectedDate);
                }
            },
            fetchMinuteTiming(date) {
                if (!this.canViewMinuteTiming) {
                    return;
                }
                this.isFetchingMinuteTiming = true;
                let url = `/v3/sentiment/distribute_timing?date1=${date}&days=6`;
                request_zzquant({ url: url }).then(res => {
                    this.isFetchingMinuteTiming = false;
                    this.requireMinuteSubscription = false;
                    const now = new Date();
                    const h = String(now.getHours()).padStart(2, '0');
                    const m = String(now.getMinutes()).padStart(2, '0');
                    const s = String(now.getSeconds()).padStart(2, '0');
                    this.lastMinuteUpdateTime = `${h}:${m}:${s}`;
                    let currentData = res.data.data || [];
                    let amountHistory = res.data.amount_history || {};
                    let dates = res.data.dates || [date];

                    // 1. 收集全部分钟时间轴 (categories) - 库中有什么分钟数据均全部展示，不固定为5分钟
                    const normalizeMinute = (m) => {
                        if (!m) return '';
                        let str = String(m).trim();
                        if (str.length === 5) return `${str}:00`;
                        if (str.length === 7 && str[1] === ':') return `0${str}`;
                        if (str.length === 4 && str[1] === ':') return `0${str}:00`;
                        return str;
                    };

                    let categories = [];
                    const addCategory = (m) => {
                        const norm = normalizeMinute(m);
                        if (norm && !categories.includes(norm)) {
                            categories.push(norm);
                        }
                    };
                    currentData.forEach(item => addCategory(item.minute));
                    // 若当天数据偏少（如盘中刚开盘），补充历史交易日的完整分钟轴
                    dates.forEach(d => {
                        let historyItems = amountHistory[d] || [];
                        historyItems.forEach(item => addCategory(item.minute));
                    });
                    categories.sort();

                    // 2. 组装今日分钟择时数据
                    let timingMap = {};
                    currentData.forEach(item => {
                        timingMap[normalizeMinute(item.minute)] = item.market_timing || 0;
                    });
                    let timingValues = categories.map(m => (timingMap[m] !== undefined ? timingMap[m] : 0));

                    // 3. 组装近三天的分时成交额折线、5日均量与量差数据
                    const isDark = document.body.classList.contains('theme-dark') || document.documentElement.classList.contains('theme-dark');
                    const upColor = this.colorblind ? '#E69F00' : '#ec0000';
                    const downColor = this.colorblind ? '#0072B2' : '#00da3c';
                    const upColorAlpha = this.colorblind ? 'rgba(230, 159, 0, 0.15)' : 'rgba(236, 0, 0, 0.15)';
                    const downColorAlpha = this.colorblind ? 'rgba(0, 114, 178, 0.15)' : 'rgba(0, 218, 60, 0.15)';
                    const ma5UpBorder = this.colorblind ? '#E69F00' : '#ec0000';
                    const subUpBorder = this.colorblind ? 'rgba(230, 159, 0, 0.7)' : 'rgba(236, 0, 0, 0.65)';
                    const textColor = isDark ? '#94a3b8' : '#64748b';
                    const splitColor = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)';

                    // 构建每日分时 amount_bi 映射字典
                    let dayMaps = {};
                    dates.forEach(d => {
                        let dayHistory = amountHistory[d] || [];
                        let dMap = {};
                        dayHistory.forEach(h => {
                            dMap[normalizeMinute(h.minute)] = h.amount_bi;
                        });
                        dayMaps[d] = dMap;
                    });

                    // 识别目标选定日与历史日
                    const todayDate = dates.includes(date) ? date : (dates.length > 0 ? dates[dates.length - 1] : date);
                    const histDates = dates.filter(d => d !== todayDate);
                    const numHist = histDates.length;
                    const yesterdayDate = numHist >= 1 ? histDates[numHist - 1] : null;
                    const beforeYesterdayDate = numHist >= 2 ? histDates[numHist - 2] : null;
                    const ma5Dates = histDates.slice(-5); // 取目标日之前的最近至多 5 个历史交易日

                    let todayMap = dayMaps[todayDate] || {};
                    currentData.forEach(item => {
                        const normM = normalizeMinute(item.minute);
                        if (todayMap[normM] === undefined && item.amount_bi !== undefined) {
                            todayMap[normM] = item.amount_bi;
                        }
                    });
                    dayMaps[todayDate] = todayMap;

                    let yesterdayMap = yesterdayDate ? (dayMaps[yesterdayDate] || {}) : {};
                    let beforeYesterdayMap = beforeYesterdayDate ? (dayMaps[beforeYesterdayDate] || {}) : {};

                    // 计算较昨日量差 (今日 - 昨日，实心红绿柱展示)
                    let diffValues = [];
                    if (yesterdayDate) {
                        diffValues = categories.map(m => {
                            const tVal = todayMap[m];
                            const yVal = yesterdayMap[m];
                            if (tVal !== undefined && tVal !== null && yVal !== undefined && yVal !== null) {
                                return +(tVal - yVal).toFixed(2);
                            }
                            return null;
                        });
                    }

                    // 计算每根有效柱相比前一根有效柱的放量/缩量环比变动 (用于放量/缩量 > 100亿异动标记)
                    let diffDeltas = new Array(categories.length).fill(null);
                    let lastValidIdx = -1;
                    for (let i = 0; i < diffValues.length; i++) {
                        const curVal = diffValues[i];
                        if (curVal !== null && curVal !== undefined) {
                            if (lastValidIdx !== -1) {
                                const prevVal = diffValues[lastValidIdx];
                                diffDeltas[i] = +(curVal - prevVal).toFixed(2);
                            }
                            lastValidIdx = i;
                        }
                    }
                    this.minuteDiffValues = diffValues;
                    this.minuteDiffDeltas = diffDeltas;

                    // 计算较前日量差 (今日 - 前日，次要对比，浅色边框柱)
                    let diffBeforeValues = [];
                    if (beforeYesterdayDate) {
                        diffBeforeValues = categories.map(m => {
                            const tVal = todayMap[m];
                            const bVal = beforeYesterdayMap[m];
                            if (tVal !== undefined && tVal !== null && bVal !== undefined && bVal !== null) {
                                return +(tVal - bVal).toFixed(2);
                            }
                            return null;
                        });
                    }

                    // 计算 5 日均量分时 (后端优先，前端兜底)
                    let ma5BackendMap = {};
                    if (Array.isArray(res.data.ma5_history)) {
                        res.data.ma5_history.forEach(item => {
                            ma5BackendMap[normalizeMinute(item.minute)] = item.amount_bi;
                        });
                    }

                    let ma5Values = categories.map(m => {
                        if (ma5BackendMap[m] !== undefined && ma5BackendMap[m] !== null) {
                            return ma5BackendMap[m];
                        }
                        if (ma5Dates.length > 0) {
                            const vals = ma5Dates
                                .map(d => (dayMaps[d] ? dayMaps[d][m] : null))
                                .filter(v => v !== undefined && v !== null);
                            if (vals.length > 0) {
                                return +(vals.reduce((a, b) => a + b, 0) / vals.length).toFixed(2);
                            }
                        }
                        return null;
                    });

                    // 计算较 5 日量差 (今日 - 5日均量)
                    let diffMA5Values = [];
                    if (ma5Dates.length > 0) {
                        diffMA5Values = categories.map((m, idx) => {
                            const tVal = todayMap[m];
                            const maVal = ma5Values[idx];
                            if (tVal !== undefined && tVal !== null && maVal !== undefined && maVal !== null) {
                                return +(tVal - maVal).toFixed(2);
                            }
                            return null;
                        });
                    }

                    // 4. 组装今日均涨幅走势 (series[1])
                    let avgPctMap = {};
                    currentData.forEach(item => {
                        if (item.avg_pct !== undefined && item.avg_pct !== null) {
                            avgPctMap[normalizeMinute(item.minute)] = item.avg_pct;
                        }
                    });
                    let avgPctValues = categories.map(m => (avgPctMap[m] !== undefined ? avgPctMap[m] : null));
                    if (this.minuteLine.series[1]) {
                        this.minuteLine.series[1].data = avgPctValues;
                    }

                    // 5. 更新较昨日量差柱状图 (series[2] - 主要，实心红绿柱，放量/缩量超百亿标记)
                    if (this.minuteLine.series[2]) {
                        // 在数据项中直接注入静态 position，保持量柱原生实心样式不变，放量数字在上、箭头在下
                        let diffSeriesData = diffValues.map((val, idx) => {
                            if (val === null || val === undefined) return null;
                            const delta = diffDeltas[idx];
                            if (delta !== null && delta !== undefined) {
                                if (delta >= 100) {
                                    return {
                                        value: val,
                                        label: {
                                            show: true,
                                            position: 'top',
                                            distance: 5
                                        }
                                    };
                                }
                                if (delta <= -100) {
                                    return {
                                        value: val,
                                        label: {
                                            show: true,
                                            position: 'bottom',
                                            distance: 5
                                        }
                                    };
                                }
                            }
                            return {
                                value: val,
                                label: {
                                    show: false
                                }
                            };
                        });
                        this.minuteLine.series[2].data = diffSeriesData;
                        this.minuteLine.series[2].itemStyle = {
                            color: (params) => {
                                let val = params.value;
                                if (typeof val === 'object' && val !== null) {
                                    val = val.value !== undefined ? val.value : val;
                                }
                                val = Number(val);
                                const is0930 = (params.name && params.name.startsWith('09:30')) ||
                                    (categories[params.dataIndex] && categories[params.dataIndex].startsWith('09:30'));
                                if (is0930) {
                                    return val >= 0 ? upColorAlpha : downColorAlpha;
                                }
                                return val >= 0 ? upColor : downColor;
                            },
                            borderColor: 'transparent',
                            borderWidth: 0,
                            borderRadius: [2, 2, 0, 0]
                        };
                        if (this.minuteLine.series[2].markLine && this.minuteLine.series[2].markLine.data && this.minuteLine.series[2].markLine.data[0]) {
                            this.minuteLine.series[2].markLine.data[0].lineStyle.color = isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.15)';
                        }
                        const surgeColor = isDark
                            ? upColor
                            : (this.colorblind ? '#d97706' : '#dc2626');
                        const plungeColor = isDark
                            ? downColor
                            : (this.colorblind ? '#0284c7' : '#16a34a');
                        const surgeBg = isDark
                            ? 'rgba(10, 15, 30, 0.92)'
                            : (this.colorblind ? '#fffbeb' : '#fff1f0');
                        const plungeBg = isDark
                            ? 'rgba(10, 15, 30, 0.92)'
                            : (this.colorblind ? '#f0f9ff' : '#f6ffed');
                        const surgeBorder = isDark
                            ? upColor
                            : (this.colorblind ? 'rgba(217, 119, 6, 0.45)' : 'rgba(220, 38, 38, 0.45)');
                        const plungeBorder = isDark
                            ? downColor
                            : (this.colorblind ? 'rgba(2, 132, 199, 0.45)' : 'rgba(22, 163, 74, 0.45)');
                        const tagShadowColor = isDark ? 'rgba(0, 0, 0, 0.6)' : 'transparent';
                        const tagShadowBlur = isDark ? 3 : 0;

                        this.minuteLine.series[2].label = {
                            distance: 5,
                            formatter: (params) => {
                                const idx = params.dataIndex;
                                const delta = diffDeltas[idx];
                                if (delta !== null && delta !== undefined) {
                                    if (delta >= 100) {
                                        // 放量：数字在上面，箭头在下面紧贴柱顶向上指
                                        return `{surge|${Math.round(delta)}\n↑}`;
                                    }
                                    if (delta <= -100) {
                                        // 缩量：箭头在上面紧贴柱底向下指，数字在下面
                                        return `{plunge|↓\n${Math.abs(Math.round(delta))}}`;
                                    }
                                }
                                return '';
                            },
                            rich: {
                                surge: {
                                    color: surgeColor,
                                    backgroundColor: surgeBg,
                                    borderColor: surgeBorder,
                                    borderWidth: 1,
                                    borderRadius: 3,
                                    padding: [2, 3],
                                    fontSize: 9,
                                    fontWeight: 'bold',
                                    align: 'center',
                                    lineHeight: 11,
                                    shadowBlur: tagShadowBlur,
                                    shadowColor: tagShadowColor
                                },
                                plunge: {
                                    color: plungeColor,
                                    backgroundColor: plungeBg,
                                    borderColor: plungeBorder,
                                    borderWidth: 1,
                                    borderRadius: 3,
                                    padding: [2, 3],
                                    fontSize: 9,
                                    fontWeight: 'bold',
                                    align: 'center',
                                    lineHeight: 11,
                                    shadowBlur: tagShadowBlur,
                                    shadowColor: tagShadowColor
                                }
                            }
                        };
                    }

                    // 6. 更新较 5 日量差柱状图 (series[3] - 5日基准对比，虚线边框红绿柱)
                    if (this.minuteLine.series[3]) {
                        this.minuteLine.series[3].data = diffMA5Values;
                        const ma5UpColor = this.colorblind ? 'rgba(230, 159, 0, 0.45)' : 'rgba(236, 0, 0, 0.45)';
                        const ma5DownColor = this.colorblind ? 'rgba(0, 114, 178, 0.45)' : 'rgba(0, 218, 60, 0.45)';
                        const ma5UpBorder = this.colorblind ? '#E69F00' : '#ec0000';
                        const ma5DownBorder = this.colorblind ? '#0072B2' : '#00da3c';
                        this.minuteLine.series[3].itemStyle = {
                            color: (params) => {
                                const val = params.value;
                                return val >= 0 ? ma5UpColor : ma5DownColor;
                            },
                            borderColor: (params) => {
                                const val = params.value;
                                return val >= 0 ? ma5UpBorder : ma5DownBorder;
                            },
                            borderWidth: 1,
                            borderType: 'dashed',
                            borderRadius: [2, 2, 0, 0]
                        };
                    }

                    // 7. 更新较前日量差柱状图 (series[4] - 次要，半透明浅色柱，与昨日柱并列)
                    if (this.minuteLine.series[4]) {
                        this.minuteLine.series[4].data = diffBeforeValues;
                        const subUpColor = this.colorblind ? 'rgba(230, 159, 0, 0.38)' : 'rgba(236, 0, 0, 0.35)';
                        const subDownColor = this.colorblind ? 'rgba(0, 114, 178, 0.38)' : 'rgba(0, 218, 60, 0.35)';
                        const subUpBorder = this.colorblind ? 'rgba(230, 159, 0, 0.7)' : 'rgba(236, 0, 0, 0.65)';
                        const subDownBorder = this.colorblind ? 'rgba(0, 114, 178, 0.7)' : 'rgba(0, 218, 60, 0.65)';
                        this.minuteLine.series[4].itemStyle = {
                            color: (params) => {
                                const val = params.value;
                                return val >= 0 ? subUpColor : subDownColor;
                            },
                            borderColor: (params) => {
                                const val = params.value;
                                return val >= 0 ? subUpBorder : subDownBorder;
                            },
                            borderWidth: 1,
                            borderRadius: [2, 2, 0, 0]
                        };
                    }

                    // 8. 组装近三日实际成交额曲线 (series[5..7]) 与 5日均量曲线 (series[8])
                    const lineConfigs = [
                        { color: '#64748b', type: 'dotted', width: 1.2 }, // 前日
                        { color: '#38bdf8', type: 'solid', width: 1.6 },  // 昨日
                        { color: '#f59e0b', type: 'solid', width: 2.2 }   // 今日
                    ];

                    for (let i = 5; i <= 8; i++) {
                        if (this.minuteLine.series[i]) {
                            this.minuteLine.series[i].data = [];
                            this.minuteLine.series[i].name = '';
                        }
                    }

                    this.minuteLine.color = [
                        '#a855f7',
                        upColor,
                        ma5UpBorder,
                        subUpBorder,
                        '#64748b',
                        '#38bdf8',
                        '#f59e0b',
                        '#a855f7'
                    ];

                    let legendNames = ['均涨幅'];
                    if (yesterdayDate) {
                        legendNames.push({
                            name: '较昨日量差',
                            icon: 'roundRect',
                            itemStyle: {
                                color: upColor,
                                borderColor: upColor
                            }
                        });
                    }
                    if (ma5Dates.length > 0) {
                        legendNames.push({
                            name: '较5日量差',
                            icon: 'roundRect',
                            itemStyle: {
                                color: upColorAlpha,
                                borderColor: ma5UpBorder,
                                borderWidth: 1,
                                borderType: 'dashed'
                            }
                        });
                    }
                    if (beforeYesterdayDate) {
                        legendNames.push({
                            name: '较前日量差',
                            icon: 'roundRect',
                            itemStyle: {
                                color: upColorAlpha,
                                borderColor: subUpBorder,
                                borderWidth: 1
                            }
                        });
                    }

                    // 绘制近三日实际曲线 (D-2, D-1, Today) -> 严格对应 series[5..7]
                    const recent3Dates = dates.slice(-3);
                    const numDates = recent3Dates.length;
                    recent3Dates.forEach((d, idx) => {
                        let seriesIdx = 7 - (numDates - 1 - idx);
                        let config = lineConfigs[seriesIdx - 5] || lineConfigs[2];
                        let shortDate = d.length > 5 ? d.slice(5) : d;
                        let lineName = idx === numDates - 1 ? `${shortDate} (选定)` : `${shortDate}`;

                        legendNames.push(lineName);
                        let dayMap = dayMaps[d] || {};
                        let amountValues = categories.map(m => (dayMap[m] !== undefined ? dayMap[m] : null));

                        if (this.minuteLine.series[seriesIdx]) {
                            this.minuteLine.series[seriesIdx].name = lineName;
                            this.minuteLine.series[seriesIdx].data = amountValues;
                            this.minuteLine.series[seriesIdx].lineStyle = {
                                color: config.color,
                                type: config.type,
                                width: config.width
                            };
                            this.minuteLine.series[seriesIdx].itemStyle = {
                                color: config.color
                            };
                        }
                    });

                    // 绘制 5 日均量曲线 (series[8]) - 视觉比前日更淡化更弱化，作为背景基准参考线
                    if (this.minuteLine.series[8] && ma5Dates.length > 0) {
                        this.minuteLine.series[8].name = '5日均量';
                        this.minuteLine.series[8].data = ma5Values;
                        const ma5FadedColor = isDark ? 'rgba(148, 163, 184, 0.35)' : 'rgba(100, 116, 139, 0.35)';
                        this.minuteLine.series[8].lineStyle = {
                            color: ma5FadedColor,
                            type: 'dotted',
                            width: 1.0
                        };
                        this.minuteLine.series[8].itemStyle = {
                            color: isDark ? '#64748b' : '#94a3b8'
                        };
                        legendNames.push('5日均量');
                    }

                    // 更新坐标轴数据与样式
                    if (this.minuteLine.xAxis[0]) {
                        this.minuteLine.xAxis[0].data = categories;
                    }
                    if (this.minuteLine.xAxis[1]) {
                        this.minuteLine.xAxis[1].data = categories;
                        this.minuteLine.xAxis[1].axisLabel.color = textColor;
                    }
                    if (this.minuteLine.yAxis[1]) {
                        this.minuteLine.yAxis[1].splitLine.lineStyle.color = splitColor;
                        this.minuteLine.yAxis[1].axisLabel.color = textColor;
                        if (this.minuteLine.yAxis[1].nameTextStyle) this.minuteLine.yAxis[1].nameTextStyle.color = textColor;
                    }
                    if (this.minuteLine.yAxis[2]) {
                        this.minuteLine.yAxis[2].axisLabel.color = textColor;
                        if (this.minuteLine.yAxis[2].nameTextStyle) this.minuteLine.yAxis[2].nameTextStyle.color = textColor;
                    }
                    if (this.minuteLine.yAxis[3]) {
                        this.minuteLine.yAxis[3].axisLabel.color = textColor;
                        if (this.minuteLine.yAxis[3].nameTextStyle) this.minuteLine.yAxis[3].nameTextStyle.color = textColor;
                    }
                    if (this.minuteLine.legend) {
                        this.minuteLine.legend.data = legendNames;
                        this.minuteLine.legend.textStyle.color = textColor;
                    }

                    this.minuteLine.series[0].data = timingValues;
                    this.minuteLine.series[0].itemStyle.color = (params) => {
                        const val = params.value;
                        const is0930 = (params.name && params.name.startsWith('09:30')) ||
                            (categories[params.dataIndex] && categories[params.dataIndex].startsWith('09:30'));
                        if (val > 0) return is0930 ? upColorAlpha : upColor;
                        if (val < 0) return is0930 ? downColorAlpha : downColor;
                        return 'transparent';
                    };
                    if (this.minuteLine.series[0].label) {
                        this.minuteLine.series[0].label.color = (params) => {
                            const is0930 = (params.name && params.name.startsWith('09:30')) ||
                                (categories[params.dataIndex] && categories[params.dataIndex].startsWith('09:30'));
                            return is0930 ? 'rgba(255, 255, 255, 0.2)' : '#fff';
                        };
                    }
                }).catch(err => {
                    this.isFetchingMinuteTiming = false;
                    this.minuteDiffValues = [];
                    this.minuteDiffDeltas = [];
                    if (err.status === 403 || err.code === 403 || (err.message && err.message.includes('403'))) {
                        this.requireMinuteSubscription = true;
                        if (this.minuteLine.xAxis[0]) this.minuteLine.xAxis[0].data = [];
                        if (this.minuteLine.xAxis[1]) this.minuteLine.xAxis[1].data = [];
                        this.minuteLine.series.forEach(s => { s.data = []; });
                    }
                });
            },
            refresh(data_start) {
                const isDark = document.body.classList.contains('theme-dark') || document.documentElement.classList.contains('theme-dark');
                const upColor = this.colorblind ? '#E69F00' : '#ec0000'
                const downColor = this.colorblind ? '#0072B2' : '#00da3c'
                const textColor = isDark ? '#94a3b8' : '#64748b'
                const borderColor = isDark ? '#334155' : '#e2e8f0'
                const ma5Color = "#5c74f0"
                const volMaColor = "#ff9800"
                const chartLayout = this.getChartLayout();
                const showAdminMarketPanels = this.isAdmin
                
                // Update chart colors dynamically
                if (this.line.title && this.line.title.textStyle) this.line.title.textStyle.color = textColor;
                if (this.line.legend) {
                    this.line.legend.data = this.getChartLegendData();
                    if (this.line.legend.textStyle) this.line.legend.textStyle.color = textColor;
                }
                this.line.grid = chartLayout.grid;
                this.line.xAxis = chartLayout.xAxis;
                this.line.yAxis = chartLayout.yAxis;
                if (this.line.dataZoom && this.line.dataZoom[0]) {
                    this.line.dataZoom[0].xAxisIndex = chartLayout.dataZoomXAxisIndex;
                    this.line.dataZoom[0].top = chartLayout.dataZoomTop;
                }
                this.line.color = [upColor, ma5Color, upColor, upColor, downColor, ma5Color, ma5Color, ma5Color, volMaColor]
                this.line.yAxis.forEach(axis => {
                    if (axis.axisLabel) axis.axisLabel.color = textColor;
                    if (axis.nameTextStyle) axis.nameTextStyle.color = textColor;
                    if (axis.axisLine && axis.axisLine.lineStyle) axis.axisLine.lineStyle.color = borderColor;
                });
                if (this.line.dataZoom[0].textStyle) this.line.dataZoom[0].textStyle.color = textColor;
                
                // 手机端调整网格边距
                const isMobilLayout = window.innerWidth <= 768;
                const gridLeft = isMobilLayout ? 55 : 50;
                const gridRight = isMobilLayout ? 10 : 60;
                this.line.grid.forEach(g => { g.left = gridLeft; g.right = gridRight; });
                
                // 手机端精简图例
                const mobilHiddenLegends = new Set(['MA5', '大盘K', '大盘MA5', '成交额MA5']);
                const allLegends = this.getChartLegendData();
                this.line.legend.data = isMobilLayout
                    ? allLegends.filter(item => !mobilHiddenLegends.has(item))
                    : allLegends;
                
                let url_k = '/v3/api/sentiment/kline/day/'+this.modal+'?date1='
                let url = '/v3/sentiment/data?date1='
                let url_timing = '/v3/sentiment/timing?date1='
                let url_market_k = `/v3/market/kline/plate/${this.marketModal}?date1=`
                let url_market_v = '/v3/market/kline/plate/883957?date1='
                
                const dateQuery = data_start || (window.innerWidth <= 768 ? Moment().add(-6,'months').format('YYYY-MM-DD') : Moment().add(-1,'years').format('YYYY-MM-DD'));
                url += dateQuery;
                url_k += dateQuery;
                url_timing += dateQuery;
                url_market_k += dateQuery;
                url_market_v += dateQuery;
                const trendUrl = '/v3/market/kline/plate/883957?date1=' + Moment(dateQuery).subtract(400, 'days').format('YYYY-MM-DD');
                
                const handleRes = (promise) => promise.then(res => res).catch(err => ({ error: true, data: err }));

                Promise.all([
                    handleRes(request_zzquant({ url: url_k })),
                    handleRes(request_zzquant({ url: url })),
                    handleRes(request_zzquant({ url: url_timing })),
                    handleRes(request_zzquant({ url: url_market_k })),
                    this.marketModal !== 883957 ? handleRes(request_zzquant({ url: url_market_v })) : Promise.resolve(null),
                    handleRes(request_zzquant({ url: trendUrl }))
                ]).then(([klineRes, sentimentRes, timingRes, marketKRes, marketVRes, trendRes]) => {
                    this.requireSubscription = false;
                    
                    if (!marketVRes || marketVRes.error) {
                        marketVRes = marketKRes;
                    }

                    try {
                        let klineRaw = (klineRes && !klineRes.error && klineRes.data && klineRes.data.data) || [];
                        let klineData = this.splitKlineData(klineRaw);
                        
                        let sentimentRaw = [];
                        if (sentimentRes && !sentimentRes.error && sentimentRes.data) {
                            sentimentRaw = sentimentRes.data.data || [];
                        }

                        let timingRaw = [];
                        if (timingRes) {
                            if (timingRes.error) {
                                const err = timingRes.data;
                                if (err && (err.status === 403 || err.code === 403 || err.status === 401 || err.code === 401)) {
                                    this.requireSubscription = true;
                                    this.isUnauthorized = err.status === 401 || err.code === 401;
                                    timingRaw = (err.response && err.response.data && err.response.data.data) || (err.data && err.data.data) || err.data || [];
                                }
                            } else if (timingRes.data) {
                                if (timingRes.data.code === 403 || timingRes.data.code === 401) {
                                    this.requireSubscription = true;
                                    this.isUnauthorized = timingRes.data.code === 401;
                                }
                                timingRaw = timingRes.data.data || [];
                            }
                        }

                        // 合并择时数据到 sentimentRaw 中，以便 splitData 统一处理
                        // 假设日期是对齐的
                        sentimentRaw.forEach((item) => {
                            const tItem = timingRaw.find(t => t.date1 === item.date1);
                            if (tItem) {
                                item.market_timing = tItem.market_timing;
                                item.timing_signal_type = tItem.timing_signal_type || 0;
                            }
                        });
                        
                        let splitDataItem = this.splitData(sentimentRaw);
                        const trendRows = (trendRes && !trendRes.error && trendRes.data && trendRes.data.data) || [];
                        const marketStates = buildMarketTrendDetails(trendRows, splitDataItem.categoryData);
                        const weakUpColor = getComputedStyle(document.documentElement).getPropertyValue('--timing-downtrend-positive').trim() || (isDark ? '#c97b7b' : '#b96f6f');
                        let zhabanDataItem = this.splitZhabanData(sentimentRaw);
                        
                        let marketKRaw = (marketKRes && !marketKRes.error && marketKRes.data && marketKRes.data.data) || [];
                        let marketVRaw = (marketVRes && !marketVRes.error && marketVRes.data && marketVRes.data.data) || [];
                        let marketKData = this.splitKlineData(marketKRaw);
                        let marketVData = this.splitKlineData(marketVRaw);
                        if (this.requireSubscription) {
                            // 将最近的 5 个交易日数据置空，作为右侧遮罩留白
                            const emptyCount = 5;
                            const startIndex = Math.max(0, splitDataItem.categoryData.length - emptyCount);
                            
                            // 清空最近 5 天的择时、大盘等数据，保留中间的主K线相关数据
                            for (let i = startIndex; i < splitDataItem.categoryData.length; i++) {
                                marketKData.values[i] = [null, null, null, null]; // 大盘K线为空
                                marketVData.volumes[i] = null; // 大盘成交量为0
                                
                                // 封板率、上涨数置空
                                zhabanDataItem.zb_pct[i] = null;
                                splitDataItem.up_num[i] = null;
                                
                                // 择时数据置空
                                splitDataItem.market_timing_data[i] = null;
                                splitDataItem.timing_signal_type_data[i] = 0;
                            }
                            
                            // 记录原始的 start 和 end，用于在用户拖动时恢复
                            this._originalDataZoomStart = dataZoomData.start;
                            this._originalDataZoomEnd = dataZoomData.end;
                            
                            // 保持 dataZoom 的默认显示范围，并使其显示但实际上由 onDataZoom 拦截拖拽
                            this.line.dataZoom[0].start = dataZoomData.start;
                            this.line.dataZoom[0].end = dataZoomData.end;
                            this.line.dataZoom[0].show = true; 
                            
                            // 更新 tooltip 的 formatter 以处理空数据
                            const originalFormatter = this.line.tooltip.formatter;
                            this.line.tooltip.formatter = function(params) {
                                // 如果这一天的所有数据都是空的，就不显示 tooltip
                                 const isEmpty = params.every(item => {
                                      if (item.seriesName === 'K' || item.seriesName === '大盘K') {
                                          return !item.value || item.value[1] === null || item.value[1] === undefined;
                                      }
                                      if (item.seriesName.includes('涨停板') || item.seriesName.includes('跌停板')) {
                                          return !item.value || item.value[1] === null || item.value[1] === undefined;
                                      }
                                      if (item.seriesName === '择时') {
                                           return item.value === null || item.value === undefined || item.value === '-';
                                      }
                                      return item.value === null || item.value === undefined || item.value === '-';
                                  });
                                
                                if (isEmpty) {
                                    return '';
                                }
                                
                                return originalFormatter(params);
                            };
                        } else {
                            this.line.dataZoom[0].show = true; // 有权限时显示拖动条
                        }
                        
                        let series_data = []
                        let timingSignalScatterData = this.getTimingSignalScatterData(splitDataItem, isDark);
                        
                        if (this.requireSubscription) {
                             timingSignalScatterData = timingSignalScatterData.filter(item => {
                                 const index = splitDataItem.categoryData.indexOf(item.value[0]);
                                 return index < splitDataItem.categoryData.length - 5;
                             });
                        }
                        
                        // Combined MarkLines
                        const combinedMarkLines = {
                            symbol: 'none',
                            silent: true,
                            lineStyle: { type: 'dotted', color: textColor, opacity: 0.3 },
                            label: { show: false },
                            data: [
                                // 每周第一天：竖线 + 周标记文字
                                ...klineData.mark_line_mon.map(m => ({ 
                                    xAxis: m.xAxis, 
                                    lineStyle: { opacity: 0.3, type: 'dotted' }, 
                                    label: { 
                                        show: true, 
                                        position: 'end', 
                                        formatter: m.label.formatter, 
                                        color: isDark ? '#cbd5e1' : '#475569',
                                        fontSize: 10,
                                        fontWeight: 'normal',
                                        backgroundColor: isDark ? 'rgba(15,20,40,0.8)' : 'rgba(255,255,255,0.8)',
                                        padding: [2, 4],
                                        borderRadius: 2,
                                    } 
                                })),
                                // 每月第一天：竖线更明显 + 月份文字更醒目
                                ...klineData.mark_line_day1.map(m => ({ 
                                    xAxis: m.xAxis, 
                                    lineStyle: { opacity: 0.6, type: 'dashed', color: isDark ? '#64748b' : '#94a3b8' }, 
                                    label: { 
                                        show: true, 
                                        position: 'end', 
                                        formatter: (params) => params.value.split('-')[1] + '月', 
                                        color: isDark ? '#e2e8f0' : '#1e293b',
                                        fontSize: 12,
                                        fontWeight: 'bold',
                                        backgroundColor: isDark ? 'rgba(30,30,50,0.85)' : 'rgba(255,255,255,0.9)',
                                        padding: [2, 5],
                                        borderRadius: 3,
                                        offset: [0, -18]
                                    } 
                                }))
                            ]
                        };

                        // MarkLines for Timing (no labels)
                        const timingMarkLines = {
                            symbol: 'none',
                            silent: true,
                            lineStyle: { type: 'dotted', color: textColor, opacity: 0.3 },
                            label: { show: false },
                            data: [
                                ...combinedMarkLines.data.map(m => ({ ...m, label: { show: false } })),
                                { yAxis: 0, lineStyle: { color: textColor, type: 'dashed', opacity: 0.2 } }
                            ]
                        };
                        
                        // Grid 0: Timing (Always show it, restricted logic handled by data clearing)
                        series_data.push({
                            name: '择时',
                            data: splitDataItem.market_timing_data,
                            type: 'bar',
                            xAxisIndex: 0,
                            yAxisIndex: 0,
                            barMaxWidth: 15,
                            itemStyle: {
                                color: (params) => {
                                    const val = params.value;
                                    if (val === null || val === undefined || val === '-') return 'transparent';
                                    return val > 0 ? (marketStates[splitDataItem.categoryData[params.dataIndex]].trend === 'down' ? weakUpColor : upColor) : (val < 0 ? downColor : 'transparent');
                                },
                                borderRadius: [2, 2, 0, 0]
                            },
                            label: {
                                show: true,
                                position: (params) => params.value > 0 ? 'insideTop' : 'insideBottom',
                                color: '#ffffff',
                                fontSize: 11,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    const val = params.value;
                                    if (val === null || val === undefined || val === '-') return '';
                                    if (val > 0) return '多';
                                    if (val < 0) return '空';
                                    return '';
                                }
                            },
                            z: 100,
                            markLine: timingMarkLines
                        });
                        series_data.push({
                            name: '择时信号',
                            type: 'scatter',
                            xAxisIndex: 0,
                            yAxisIndex: 0,
                            data: timingSignalScatterData,
                            symbol: 'roundRect',
                            symbolSize: [22, 18],
                            z: 120,
                            tooltip: {
                                trigger: 'item',
                                formatter: (params) => {
                                    const signalType = params.data && params.data.signalType ? params.data.signalType : 0;
                                    const signalName = this.formatTimingSignalType(signalType);
                                    return `${params.name || params.value[0]}<br/>信号: ${signalName}`;
                                }
                            }
                        });


                    // Grid 1: Main K
                    series_data.push({
                        name: "K",
                        type: 'candlestick',
                        data: klineData.values,
                        xAxisIndex: 1,
                        yAxisIndex: 1,
                        itemStyle: { color: upColor, color0: downColor, borderColor: upColor, borderColor0: downColor },
                        markPoint: { data: klineData.iceData, symbol: 'diamond', symbolSize: 8, itemStyle: { color: '#4682B4', opacity: 0.7 }, label: { show: false } },
                        markLine: combinedMarkLines
                    });

                    // Grid 2: Main Vol
                    series_data.push({
                        name: '成交额',
                        type: 'bar',
                        xAxisIndex: 2,
                        yAxisIndex: 2,
                        data: klineData.volumes,
                        itemStyle: { color: (params) => klineData.values[params.dataIndex][1] > klineData.values[params.dataIndex][0] ? upColor : downColor },
                        markLine: combinedMarkLines
                    });

                    // MA5 for Grid 1
                    series_data.push({
                        name: 'MA5',
                        data: this.calculateMAForKline(5, klineData.values),
                        type: 'line',
                        xAxisIndex: 1,
                        yAxisIndex: 1,
                        showSymbol: false,
                        lineStyle: { normal: { width: 1, opacity: 0.8, color: ma5Color } },
                        itemStyle: { normal: { color: ma5Color } }
                    });

                    // Grid 3: Highest Board
                    series_data.push({
                        name: '最高板',
                        data: splitDataItem.max_lb_num,
                        type: 'line',
                        symbol: 'diamond',
                        symbolSize: 8,
                        xAxisIndex: 3,
                        yAxisIndex: 3,
                        itemStyle: { color: upColor },
                        markPoint: { symbol: 'circle', symbolSize: 12, data: this.get_mark_point_data(splitDataItem) },
                        label: { 
                            show: true, 
                            formatter: (params) => {
                                const stocks = splitDataItem.max_lb_stocks[params.dataIndex];
                                return stocks ? stocks.replace(/[,，]/g, '\n') : '';
                            }, 
                            position: 'top', 
                            color: '#999',
                            fontSize: 10
                        },
                        lineStyle: { normal: { width: 1 } },
                        markLine: combinedMarkLines
                    });

                    // Grid 4: Limit Up/Down
                    series_data.push({
                        name: '涨停板',
                        data: splitDataItem.uplimit_num_m,
                        type: 'bar',
                        stack: "堆叠",
                        xAxisIndex: 4,
                        yAxisIndex: 4,
                        label: { show: true, position: 'top', formatter: (params) => splitDataItem.uplimit_num[params.dataIndex], color: upColor },
                        itemStyle: { normal: { color: upColor, opacity: 0.8 } },
                        markLine: combinedMarkLines
                    });
                    series_data.push({
                        name: '跌停板',
                        data: splitDataItem.downlimit_num_m,
                        type: 'bar',
                        stack: "堆叠",
                        xAxisIndex: 4,
                        yAxisIndex: 4,
                        label: { show: true, position: 'bottom', formatter: (params) => splitDataItem.downlimit_num[params.dataIndex], color: downColor },
                        itemStyle: { normal: { color: downColor, opacity: 0.8 } }
                    });

                    // Grid 5: Seal Rate
                    const zbPctNums = zhabanDataItem.zb_pct.map(v => parseFloat(v));
                    const zbAvg = (zbPctNums.reduce((a, b) => a + b, 0) / zbPctNums.length).toFixed(2);
                    
                    series_data.push({
                        name: '封板率',
                        data: zbPctNums.map((value) => {
                            return { value: value, itemStyle: { color: value > zbAvg ? upColor : downColor } };
                        }),
                        type: 'line',
                        symbol: 'circle',
                        symbolSize: 4,
                        xAxisIndex: 5,
                        yAxisIndex: 5,
                        lineStyle: { normal: { width: 1, opacity: 0.7 } },
                        label: { 
                            show: true, 
                            position: 'top', 
                            fontSize: 9, 
                            color: textColor,
                            formatter: (params) => params.dataIndex % 2 === 0 ? params.value + '%' : '' 
                        },
                        markLine: {
                            ...combinedMarkLines,
                            data: [
                                ...combinedMarkLines.data,
                                { yAxis: zbAvg, label: { position: 'end', formatter: '均值: {c}%' }, lineStyle: { color: textColor, type: 'dashed', opacity: 0.5 } }
                            ]
                        }
                    });


                    // Up Num in Grid 5
                    series_data.push({
                        name: '上涨数',
                        data: splitDataItem.up_num.map(v => {
                            return { value: v, itemStyle: { color: v < 1000 ? downColor : textColor } };
                        }),
                        type: 'line',
                        xAxisIndex: 5,
                        yAxisIndex: chartLayout.upNumYAxisIndex,
                        showSymbol: true,
                        symbol: 'circle',
                        symbolSize: (v) => v < 1000 ? 6 : 4,
                        label: { 
                            show: true, 
                            position: 'bottom', 
                            fontSize: 9, 
                            color: textColor,
                            formatter: (params) => params.value < 1000 || params.dataIndex % 2 === 0 ? params.value : '' 
                        },
                        lineStyle: { normal: { width: 1, opacity: 0.4, type: 'solid', color: textColor } },
                        markLine: {
                            ...combinedMarkLines,
                            data: [
                                ...combinedMarkLines.data,
                                { yAxis: 1000, label: { position: 'start', formatter: '冰点: 1000' }, lineStyle: { color: downColor, type: 'solid', opacity: 0.6 } }
                            ]
                        }
                    });

                    if (showAdminMarketPanels) {
                        // Grid 6: Market K
                        series_data.push({
                            name: "大盘K",
                            type: 'candlestick',
                            data: marketKData.values,
                            xAxisIndex: 6,
                            yAxisIndex: 6,
                            itemStyle: { color: upColor, color0: downColor, borderColor: upColor, borderColor0: downColor },
                            markLine: combinedMarkLines
                        });
                        
                        // Market MA5
                        series_data.push({
                            name: '大盘MA5',
                            data: this.calculateMAForKline(5, marketKData.values),
                            type: 'line',
                            xAxisIndex: 6,
                            yAxisIndex: 6,
                            showSymbol: false,
                            lineStyle: { normal: { width: 1, opacity: 0.8, color: ma5Color } },
                            itemStyle: { normal: { color: ma5Color } }
                        });

                        // Grid 7: Market Vol
                        series_data.push({
                            name: '大盘成交额',
                            type: 'bar',
                            xAxisIndex: 7,
                            yAxisIndex: 7,
                            data: marketVData.volumes,
                            itemStyle: { color: (params) => {
                                const item = marketVData.values[params.dataIndex];
                                return item && item[1] > item[0] ? upColor : downColor;
                            }},
                            label: {
                                show: true,
                                position: 'top',
                                fontSize: 9,
                                color: textColor,
                                formatter: (params) => (params.value / 1000000000000).toFixed(2)
                            },
                            markLine: combinedMarkLines
                        });

                        // Market Volume MA5
                        series_data.push({
                            name: '成交额MA5',
                            data: this.calculateMAForVolume(5, marketVData.volumes),
                            type: 'line',
                            xAxisIndex: 7,
                            yAxisIndex: 7,
                            showSymbol: false,
                            lineStyle: { normal: { width: 1, opacity: 0.8, color: volMaColor } },
                            itemStyle: { normal: { color: volMaColor } }
                        });
                    }

                    this.line.tooltip.formatter = (params) => {
                        const date = params && params[0] ? params[0].name : '';
                        let h = date + " <br />";
                        params.forEach((item) => {
                            if (item.seriesName === '择时' || item.seriesName === '择时信号') return;
                            if (item.value === null || item.value === undefined || item.value === '-') return;
                            let v = "";
                            if (item.seriesName === 'K' || item.seriesName === '大盘K') {
                                let data = item.value;
                                if (!data || data[1] === null) return;
                                let open = data[1];
                                let close = data[2];
                                let pre_close = data[5];
                                let change = ((close - pre_close) / pre_close * 100).toFixed(2);
                                v = `<span style="color:${close > open ? '#ec0000' : '#00da3c'}">${close} (${change}%)</span>`;
                            } else if (item.seriesName.includes('成交额')) {
                                v = (item.value / 100000000).toFixed(2) + ' 亿';
                            } else if (item.seriesName.includes('率')) {
                                v = item.value + '%';
                            } else {
                                v = Array.isArray(item.value) ? item.value[1] : item.value;
                            }
                            h += item.marker + " " + item.seriesName + ": " + v + " <br />";
                        });
                        const signalIndex = splitDataItem.categoryData.indexOf(date);
                        if (signalIndex >= 0 && (!this.requireSubscription || signalIndex >= splitDataItem.categoryData.length - 5)) {
                            const state = marketStates[date];
                            const trend = state ? state.trend : 'unknown';
                            const trendNames = { up: '上升通道', down: '下降通道', range: '震荡 / 通道未确认', unknown: '数据不足 / 暂不可用' };
                            h += `全A通道（截至前一交易日）: ${trendNames[state ? state.channel : 'unknown']}<br />`;
                            if (state && state.diff !== null) {
                                h += `DIFF（较早→最新）: ${state.earlierDiff.toFixed(3)} → ${state.previousDiff.toFixed(3)} → ${state.diff.toFixed(3)}<br />`;
                                if (state.channel === 'down') h += `下行确认: ${state.macdConfirmed ? '最近三个DIFF均为负且逐日降低' : 'DIFF暂未确认（须连续三值均为负且逐日降低）'}<br />`;
                            }
                            if (trend === 'down' && splitDataItem.market_timing_data[signalIndex] > 0) {
                                h += `<span style="color:${weakUpColor}">浅红多柱：下降通道 + DIFF负值扩大</span><br />`;
                            }
                            const signalType = Number(splitDataItem.timing_signal_type_data[signalIndex] || 0);
                            const signalName = this.formatTimingSignalType(signalType);
                            if (signalName) {
                                h += `<span style="color:${isDark ? '#fbbf24' : '#b45309'}">信号: ${signalName}</span><br />`;
                            }
                        }
                        return h;
                    };

                    this.line['xAxis'].forEach((axis, idx) => {
                        if (idx === 0) axis.data = splitDataItem.categoryData;
                        else if (idx < 3) axis.data = klineData.categoryData;
                        else if (idx < 5) axis.data = splitDataItem.categoryData;
                        else if (idx === 5) axis.data = zhabanDataItem.categoryData;
                        else if (showAdminMarketPanels && idx === 6) axis.data = marketKData.categoryData;
                        else if (showAdminMarketPanels && idx === 7) axis.data = marketVData.categoryData;
                    });
                    
                    this.line['series'] = series_data;

                    // 默认自动加载并展开最新交易日的分钟择时与分时量能对比数据
                    if (this.canViewMinuteTiming && splitDataItem.categoryData && splitDataItem.categoryData.length > 0) {
                        if (!this.selectedDate || !splitDataItem.categoryData.includes(this.selectedDate)) {
                            const latestDate = splitDataItem.categoryData[splitDataItem.categoryData.length - 1];
                            this.selectedDate = latestDate;
                            this.fetchMinuteTiming(latestDate);
                        } else {
                            this.fetchMinuteTiming(this.selectedDate);
                        }
                    }
                } catch (e) {
                    console.error('Processing error:', e);
                }
                }).catch(err => {
                    if (err.status === 403 || err.code === 403 || (err.message && err.message.includes('403'))) {
                        this.requireSubscription = true;
                    }
                    console.error('refresh error:', err);
                });
        }
		}
	}
</script>

<style scoped>
.sentiment-container {
	padding: 5px;
	background: var(--bg-card, #0b0c17);
	border-radius: 8px;
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.header-controls {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: -5px;
	padding: 0 10px;
}

.title-group {
	display: flex;
	flex-direction: column;
}

.main-title {
	font-size: 1.1rem;
	font-weight: bold;
	color: var(--text-main, #e0e0e0);
}

.sub-title {
	font-size: 0.9rem;
	color: var(--text-muted, #999);
	font-weight: 500;
}

.chart-day-timing {
	width: 100% !important;
	height: 1210px !important;
}

.chart-minute-timing {
	width: 100% !important;
	height: 255px !important;
}

.chart-click-disabled {
	cursor: default;
}

/* Mobile Adaptation */
@media (max-width: 768px) {
	.sentiment-container {
		padding: 5px;
	}
	.chart-day-timing {
		height: 880px !important;
	}
	.chart-minute-timing {
		height: 235px !important;
	}
	.main-title {
		font-size: 1rem;
	}
	.header-controls {
		flex-direction: column;
		align-items: flex-start;
		gap: 10px;
	}
}

.button-group {
	display: flex;
	gap: 8px;
}

.modal-button {
	font-size: 0.75rem;
	padding: 4px 10px;
	border: 1px solid var(--border-color, #3a3a4a);
	background: var(--bg-muted, #1a1b2e);
	color: var(--text-muted, #aaa);
	border-radius: 4px;
	transition: all 0.2s ease;
	cursor: pointer;
}

.modal-button:hover {
	background: var(--bg-muted);
	filter: brightness(1.2);
	color: var(--text-main);
}

.modal-button.active {
	background: var(--primary, #3b82f6);
	color: white;
	border-color: var(--primary, #3b82f6);
	box-shadow: 0 0 10px rgba(74, 108, 247, 0.3);
}

.divider {
	width: 1px;
	height: 16px;
	background: #333;
	margin: 0 5px;
}

.timing-badge {
	font-size: 0.8rem;
	font-weight: 600;
	padding: 3px 10px;
	border-radius: 6px;
	display: inline-block;
	box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.timing-badge.red {
	background: rgba(236, 0, 0, 0.15);
	color: #ff4d4d;
	border: 1px solid rgba(236, 0, 0, 0.3);
}

.timing-badge.green {
	background: rgba(0, 218, 60, 0.15);
	color: #00ff44;
	border: 1px solid rgba(0, 218, 60, 0.3);
}

.footer-note {
	margin-top: 15px;
	color: var(--text-muted, #666);
	font-size: 0.7rem;
	text-align: center;
}

.footer-note a {
	color: var(--accent-color, #4a6cf7);
	text-decoration: none;
}

/* Subscription Overlay Styles - Global Right Side */
.subscription-overlay-global {
	position: absolute;
	top: 1.5%;
	left: auto;
    right: 60px;
    width: 200px;
	height: 86.5%; /* 从顶部择时图一直覆盖到底部大盘图 */
	background: rgba(11, 12, 23, 0.45);
	backdrop-filter: blur(5px);
	-webkit-backdrop-filter: blur(5px);
	z-index: 100;
	display: flex;
	justify-content: center;
	align-items: flex-start; /* 将内容靠上对齐，放在遮罩顶部 */
	border-radius: 8px;
	overflow: hidden;
}

.overlay-content {
	text-align: center;
	background: var(--bg-card, #1a1b2e);
	padding: 15px 12px;
	border-radius: 8px;
	box-shadow: 0 5px 20px rgba(0, 0, 0, 0.6);
	width: 90%;
    margin-top: 15px; /* 距离遮罩顶部稍微留出一点间距 */
	border: 1px solid rgba(74, 108, 247, 0.4);
	animation: fadeInScale 0.3s ease-out;
	display: flex;
	align-items: center;
	flex-direction: column;
	gap: 10px;
}

@media (max-width: 768px) {
	.subscription-overlay-global {
		right: 5px !important;
		height: 87%;
		top: 0.5%;
        width: 35% !important;
	}
	.overlay-content {
		padding: 8px 6px;
		gap: 6px;
	}
	.overlay-text p {
		display: none; /* 在移动端太窄时隐藏长文本 */
	}
	.overlay-content .btn {
		padding: 2px 6px;
		font-size: 0.7rem;
		white-space: nowrap;
	}
	.lock-icon {
		font-size: 1.1rem;
	}
}

@keyframes fadeInScale {
	from { opacity: 0; transform: scale(0.9); }
	to { opacity: 1; transform: scale(1); }
}

.lock-icon {
	font-size: 1.5rem;
	color: #f59e0b;
}

.overlay-content h3 {
	margin: 0;
	font-size: 0.9rem;
	font-weight: 700;
	color: #fff;
	white-space: nowrap;
}

.overlay-content p {
	display: block; /* 恢复显示 */
	color: #94a3b8;
	margin: 0;
	font-size: 0.8rem;
	line-height: 1.4;
	text-align: left;
}

.overlay-content .instruction-link {
    display: flex; /* 恢复显示 */
    align-items: center;
    justify-content: flex-start;
    width: 100%;
}

.overlay-content .btn {
	padding: 4px 12px;
	font-size: 0.85rem;
    width: 100%;
    margin-top: 4px;
}
.disabled-btn {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: auto; /* 允许点击以触发拦截 */
}

.live-tag {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 1px 7px;
	font-size: 11px;
	color: #10b981;
	background: rgba(16, 185, 129, 0.12);
	border: 1px solid rgba(16, 185, 129, 0.3);
	border-radius: 10px;
	font-weight: normal;
	user-select: none;
}
.live-dot {
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background-color: #10b981;
	animation: pulse-dot 1.8s infinite;
}
@keyframes pulse-dot {
	0% {
		transform: scale(0.9);
		opacity: 0.6;
	}
	50% {
		transform: scale(1.3);
		opacity: 1;
	}
	100% {
		transform: scale(0.9);
		opacity: 0.6;
	}
}

.burst-hint-tag {
	display: inline-flex;
	align-items: center;
	gap: 3px;
	padding: 1px 6px;
	font-size: 11px;
	background: rgba(100, 116, 139, 0.08);
	border: 1px solid rgba(100, 116, 139, 0.22);
	border-radius: 4px;
	color: #64748b;
	user-select: none;
}
body.theme-dark .burst-hint-tag,
.theme-dark .burst-hint-tag {
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.12);
	color: #94a3b8;
}
.burst-surge-text {
	color: #dc2626;
	font-weight: 600;
}
.burst-plunge-text {
	color: #16a34a;
	font-weight: 600;
}
body.theme-dark .burst-surge-text,
.theme-dark .burst-surge-text {
	color: #ec0000;
}
body.theme-dark .burst-plunge-text,
.theme-dark .burst-plunge-text {
	color: #00da3c;
}
</style>
